{
  "schemaVersion": "1.0.0",
  "registryVersion": "1.0.0",
  "release": {
    "id": "first-ten-functional-2026-10-11",
    "sourceId": "weatherglass-first-ten",
    "sourceRevision": "first-ten-reviewed-source-v28"
  },
  "entries": [
    {
      "id": "deer-family",
      "family": "deer",
      "identity": {
        "label": "Photo-informed generic doe",
        "taxon": {
          "name": null,
          "rank": "unresolved",
          "confidence": "unverified",
          "basis": "Generic source anatomy informed by species photographs; exact species equivalence is not established."
        },
        "notes": "Current generic anatomy and movement passed the scoped scene review. Exact species comparisons and the remaining presentation limits stay open."
      },
      "habitat": [
        "woodland-meadow"
      ],
      "provenance": {
        "models": [
          {
            "id": "deer-cc0-base",
            "label": "Original Deer Female base",
            "author": "Čestmír Dammer (CDmir), with TinyWorlds",
            "license": "CC0 1.0",
            "url": "https://opengameart.org/content/deer-female",
            "notes": "Adapted in Blender; the upstream label is generic. Exact species identity is not implied."
          }
        ],
        "references": [
          {
            "id": "deer-photo-1",
            "label": "Doe side reference",
            "author": "Cephas",
            "license": "CC BY-SA 4.0",
            "url": "https://commons.wikimedia.org/wiki/File:Odocoileus_virginianus_Bic_01.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "deer-photo-2",
            "label": "Doe face reference",
            "author": "Courtney Celley / USFWS",
            "license": "Public domain",
            "url": "https://commons.wikimedia.org/wiki/File:White-tailed_deer_doe_(47256266822).jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          }
        ],
        "textures": [
          {
            "id": "deer-source-maps",
            "label": "Inherited source maps with adaptation",
            "author": "CC0 source model authors and Weatherglass adaptation",
            "license": "CC0 source asset declaration",
            "url": "https://opengameart.org/content/deer-female",
            "origin": "inherited",
            "notes": "Reference-photo pixels were not projected. Upstream source-map origin has not been independently audited."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "standing_ear_height": 1.4
        },
        "seededBounds": {
          "standing_ear_height": [
            1.344,
            1.456
          ]
        },
        "method": "Uniform artistic calibration to about 1.4 m ear height beside the 2 m cabin door; seeded size varies ±4%.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study."
        ]
      },
      "rig": {
        "id": "deer-selected-rig-v1",
        "type": "skinned",
        "roles": [
          "hips",
          "spine",
          "neck",
          "head",
          "ears",
          "tail",
          "four-limb-chains",
          "hooves"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Cautious walk",
            "description": "Cautious walk",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Diagonal trot",
            "description": "Diagonal trot",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "gaits-3",
            "kind": "procedural",
            "label": "Start and stop",
            "description": "Start and stop",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "gaits-4",
            "kind": "procedural",
            "label": "Graze",
            "description": "Graze",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "gaits-5",
            "kind": "procedural",
            "label": "Rest and look",
            "description": "Rest and look",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Wind and exposure change attention and posture",
            "description": "Wind and exposure change attention and posture",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Season changes browsing activity",
            "description": "Season changes browsing activity",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "neighbors-1",
            "kind": "procedural",
            "label": "Neighbor proximity steers head and ears; route remains reserved",
            "description": "Neighbor proximity steers head and ears; route remains reserved",
            "sourceIds": [
              "runtime-original-doe-motion"
            ]
          },
          {
            "id": "source-clip-stand",
            "kind": "clip",
            "label": "Stand (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "deer-cc0-base"
            ]
          },
          {
            "id": "source-clip-idle.000",
            "kind": "clip",
            "label": "Idle.000 (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "deer-cc0-base"
            ]
          },
          {
            "id": "source-clip-lookaround.000",
            "kind": "clip",
            "label": "LookAround.000 (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "deer-cc0-base"
            ]
          },
          {
            "id": "source-clip-eat.001",
            "kind": "clip",
            "label": "Eat.001 (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "deer-cc0-base"
            ]
          },
          {
            "id": "source-clip-run",
            "kind": "clip",
            "label": "Run (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "deer-cc0-base"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "deer-gaits-1",
            "state": "implemented",
            "label": "Cautious walk",
            "description": "Cautious walk",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          },
          {
            "id": "deer-gaits-2",
            "state": "implemented",
            "label": "Diagonal trot",
            "description": "Diagonal trot",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          },
          {
            "id": "deer-gaits-3",
            "state": "implemented",
            "label": "Start and stop",
            "description": "Start and stop",
            "actionIds": [
              "gaits-3"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          },
          {
            "id": "deer-gaits-4",
            "state": "implemented",
            "label": "Graze",
            "description": "Graze",
            "actionIds": [
              "gaits-4"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          },
          {
            "id": "deer-gaits-5",
            "state": "implemented",
            "label": "Rest and look",
            "description": "Rest and look",
            "actionIds": [
              "gaits-5"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          }
        ],
        "environment": [
          {
            "id": "deer-environment-1",
            "state": "implemented",
            "label": "Wind and exposure change attention and posture",
            "description": "Wind and exposure change attention and posture",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          },
          {
            "id": "deer-environment-2",
            "state": "implemented",
            "label": "Season changes browsing activity",
            "description": "Season changes browsing activity",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "deer-neighbors-1",
            "state": "implemented",
            "label": "Neighbor proximity steers head and ears; route remains reserved",
            "description": "Neighbor proximity steers head and ears; route remains reserved",
            "actionIds": [
              "neighbors-1"
            ],
            "sourceIds": [
              "runtime-original-doe-motion"
            ],
            "evidenceIds": [
              "deer-published-technical"
            ]
          }
        ]
      },
      "variants": [
        {
          "id": "deer-selected",
          "family": "deer",
          "label": "Generic doe",
          "assets": {
            "blender": {
              "artifactId": "sha256:d5d94a7bcc471b4b0632deeb686240952eeb930287dc87b6c22e40bde2cca1f1",
              "sha256": "d5d94a7bcc471b4b0632deeb686240952eeb930287dc87b6c22e40bde2cca1f1",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
            },
            "export": {
              "contractId": "deer-selected-export-v1",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": null,
              "notes": "This registry contract wraps the frozen export; native source rig contracts are retained in the source package."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "deer-selected-full-ce7d01cf",
                "path": "assets/wildlife/doe-original-ce7d01cf.glb",
                "sha256": "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4",
                "bytes": 2262136,
                "purpose": "Selected WebGL export.",
                "rigId": "deer-selected-rig-v1",
                "exportContractId": "deer-selected-export-v1",
                "triangles": 19168
              },
              {
                "id": "proxy",
                "payloadId": "deer-selected-proxy-5dc17284",
                "path": "assets/wildlife/doe-original-proxy-5dc17284.glb",
                "sha256": "5dc17284df270558928b161b459f8183611eee7701e1aaf3476e35400971899d",
                "bytes": 453424,
                "purpose": "Canvas fallback; visible macro simplification.",
                "rigId": "deer-selected-rig-v1",
                "exportContractId": "deer-selected-export-v1",
                "triangles": 3638
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Selected CC0 source-rig exports retain inherited photographic/baked maps whose upstream pixel origins were not independently audited. Additional anatomy-reference photographs informed shape and pose; those new reference pixels were not projected onto the model."
        },
        "anatomy": {
          "state": "validated",
          "evidenceIds": [
            "deer-generic-anatomy-534"
          ],
          "reason": "Connected generic anatomy and surface continuity passed the actual-scene gate. Species-level accuracy remains open.",
          "validation": {
            "sourceHashes": {
              "blender": "d5d94a7bcc471b4b0632deeb686240952eeb930287dc87b6c22e40bde2cca1f1"
            },
            "assetHashes": [
              "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4"
            ],
            "renderer": "webgl",
            "lods": [
              "full"
            ],
            "variantIds": [
              "deer-selected"
            ],
            "fixtureIds": [
              "deer-calibrated-rest",
              "deer-calibrated-movement"
            ],
            "date": "2026-10-11",
            "scope": "Bounded photo-informed generic anatomy and connected surface gate under actual landscape light; exact species anatomy remains unverified.",
            "limitations": [
              "Generic source identity; exact cottontail or white-tailed deer equivalence is not established.",
              "Faces, coats and muscle contours are simplified.",
              "Proxy macro anatomy is outside this full-detail visual claim."
            ]
          }
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "deer-published-technical"
          ],
          "reason": "Adaptive walking phase reduces default same-hoof cycles from 24 to 9 and from 21 to 6–7 per quarter, with folded recovery. Bounded native gait review passed; biological timing and broader gait coverage remain unverified. See docs/DEER-GAIT-CORRECTION.md."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "deer-published-technical"
          ],
          "reason": "Only the listed causal responses are implemented; no broader animal intelligence is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "deer-published-technical"
          ],
          "reason": "The adaptive walk passed independent all-quarter actual-skin contact and reachable-limb review, with small local mixed-weight hoof-edge flex. Existing technical evidence remains hash-scoped; see docs/DEER-GAIT-CORRECTION.md for the current bounded result."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "deer-published-technical",
            "deer-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "deer-published-technical"
          ],
          "reason": "Current landscape focus is available. Macro groundcover scale, contact light and proxy detail remain presentation limits."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "deer-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 2
        },
        "budgets": {
          "standardTriangles": 19168,
          "fallbackTriangles": 3638
        }
      }
    },
    {
      "id": "frog-family",
      "family": "frog",
      "identity": {
        "label": "Common frog study",
        "taxon": {
          "name": "Rana temporaria",
          "rank": "species-reference-target",
          "confidence": "low",
          "basis": "Reference target recorded by the artist; species-level anatomical accuracy remains under review."
        },
        "notes": "Photo-informed common frog with continuous haunch/chest skin and 18 toes. Bank rest, coordinated push, leap, forecatch, settle and repositioning turns are implemented. Swimming and species-specific neighbor responses remain absent."
      },
      "habitat": [
        "pond-bank"
      ],
      "provenance": {
        "models": [
          {
            "id": "frog-original-source",
            "label": "Original Blender-authored model",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:aae9265ca19c7874386dd4b09745faf71544d0882d0caab456463b04524dd911",
            "sha256": "aae9265ca19c7874386dd4b09745faf71544d0882d0caab456463b04524dd911",
            "notes": "Original continuous-skin common-frog reference study with four fore digits and five hind digits per side. Editable source retained."
          }
        ],
        "references": [
          {
            "id": "frog-photo-1",
            "label": "Common frog side view",
            "author": "Holger Krisp",
            "license": "CC BY 3.0",
            "url": "https://commons.wikimedia.org/wiki/File:Grasfrosch-Rana-temporaria-side.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          }
        ],
        "textures": [
          {
            "id": "frog-original-maps",
            "label": "Original procedural color maps",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:30602b1db51e841745953320520d51cca8a7c78942db66b4a43c25001d1aaef7",
            "sha256": "30602b1db51e841745953320520d51cca8a7c78942db66b4a43c25001d1aaef7",
            "origin": "procedural",
            "notes": "Original procedural skin spots, color, roughness and normal maps; no reference-photo pixels copied."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "authored_rest_radius": 0.066,
          "authored_swept_radius": 0.17
        },
        "seededBounds": {},
        "method": "Metre-authored engineering envelopes, including the source action and bank attitude; fixed before loading. These are support bounds rather than biological body-length measurements.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study.",
          "Per-resident seeded size and animated extents must be measured from the actual posed skin."
        ]
      },
      "rig": {
        "id": "frog-selected-rig-v2",
        "type": "skinned",
        "roles": [
          "root",
          "torso",
          "head",
          "four-fixed-length-limb-chains",
          "18-digits"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Bank rest, planted push, leap, forecatch, settle and reposition",
            "description": "Two authored clips sampled absolutely, with fixed-length terrain limb targets and preplanned C2 root propulsion. Turns reposition feet and are not certified planted.",
            "sourceIds": [
              "runtime-original-frog-study",
              "runtime-frog-pose",
              "runtime-frog-contact-ik"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Weather changes activity and resting head posture",
            "description": "Weather/activity values influence visibility and a bounded shelter head posture; source clock and foot anchors do not reset.",
            "sourceIds": [
              "runtime-frog-pose",
              "runtime-original-frog-study"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Season can make the resident inactive",
            "description": "Season can make the resident inactive",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "frog-gaits-1",
            "state": "implemented",
            "label": "Bank rest, planted push, leap, forecatch, settle and reposition",
            "description": "Two authored clips sampled absolutely, with fixed-length terrain limb targets and preplanned C2 root propulsion. Turns reposition feet and are not certified planted.",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-original-frog-study",
              "runtime-frog-pose",
              "runtime-frog-contact-ik"
            ],
            "evidenceIds": [
              "frog-bank-stance-handoff"
            ]
          }
        ],
        "environment": [
          {
            "id": "frog-environment-1",
            "state": "implemented",
            "label": "Weather changes activity and resting head posture",
            "description": "Weather/activity values influence visibility and a bounded shelter head posture; source clock and foot anchors do not reset.",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-frog-pose",
              "runtime-original-frog-study"
            ],
            "evidenceIds": [
              "frog-bank-stance-handoff"
            ]
          },
          {
            "id": "frog-environment-2",
            "state": "implemented",
            "label": "Season can make the resident inactive",
            "description": "Season can make the resident inactive",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "frog-bank-stance-handoff"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "frog-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "frog-selected",
          "family": "frog",
          "label": "Common frog",
          "assets": {
            "blender": {
              "artifactId": "sha256:aae9265ca19c7874386dd4b09745faf71544d0882d0caab456463b04524dd911",
              "sha256": "aae9265ca19c7874386dd4b09745faf71544d0882d0caab456463b04524dd911",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable source or recipe is available in the separate authoring handoff; not bundled as a browser download."
            },
            "export": {
              "contractId": "frog-selected-export-v2",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:30602b1db51e841745953320520d51cca8a7c78942db66b4a43c25001d1aaef7",
                "sha256": "30602b1db51e841745953320520d51cca8a7c78942db66b4a43c25001d1aaef7",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Editable source or recipe is available in the separate authoring handoff; not bundled as a browser download."
              },
              "notes": "Frozen metre-authored 37-joint rig; source clips, transformed inverse binds, 18 actual surface probes and exact whole-skin support are checked at the adapter boundary. Narrow provenance exception for this original export is SHA-bound."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "frog-selected-full-001c74bd",
                "path": "assets/wildlife/frog-bank-001c74bd.glb",
                "sha256": "001c74bda3317d7a2b83ad56ec21277064df7e8c017da1ca432b5dbbdc192df3",
                "bytes": 4216388,
                "purpose": "Primary close-detail skin with 37 joints and 18 distal contact probes.",
                "rigId": "frog-selected-rig-v2",
                "exportContractId": "frog-selected-export-v2",
                "triangles": 20680
              },
              {
                "id": "proxy",
                "payloadId": "frog-selected-proxy-eaaa929a",
                "path": "assets/wildlife/frog-bank-proxy-eaaa929a.glb",
                "sha256": "eaaa929aa67c36e01d6848633fa33e39741d9961459666a621a7c61d6054ba04",
                "bytes": 466268,
                "purpose": "Compact Canvas/distant skin. Hidden inner-thigh fold differs locally by 4.2 mm. Primary WebGL close views use the full mesh; Canvas keeps the compact version.",
                "rigId": "frog-selected-rig-v2",
                "exportContractId": "frog-selected-export-v2",
                "triangles": 3322
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff"
          ],
          "reason": "Original Blender source and procedural maps are recorded; reference photos inform shape and are not embedded."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff"
          ],
          "reason": "Continuous skinned body, four fore digits and five hind toes per side passed bounded source/scene deformation review. Eye rims, lip and angular fold highlights remain simplified."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff"
          ],
          "reason": "Fixed-length planted propulsion, forecatch and settle pass the four-seed full/proxy corpus and exact native witnesses. Turns reposition feet; swimming is not implemented."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff"
          ],
          "reason": "Season/weather activity and resting head response are implemented. No species-specific neighbor interaction is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff"
          ],
          "reason": "Actual skin stays above rendered terrain; planted pure soles remain fixed through push/catch/settle. Mixed foot-skin drift is bounded to 0.46 mm in reviewed cases. All-prop clearance and planted turning are not claimed."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff",
            "frog-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "frog-bank-stance-handoff",
            "frog-normal-selection-v26"
          ],
          "reason": "Normal selected primary bank views and corrected Canvas close bank/water pass the scoped review. Macro plants and compact hidden-fold differences remain limits."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "frog-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 3
        },
        "budgets": {
          "standardTriangles": 20680,
          "fallbackTriangles": 3322
        }
      }
    },
    {
      "id": "butterfly-family",
      "family": "butterfly",
      "identity": {
        "label": "Butterfly studies",
        "taxon": {
          "name": null,
          "rank": "unresolved",
          "confidence": "unverified",
          "basis": "Reference target recorded by the artist; species-level anatomical accuracy remains under review."
        },
        "notes": "Three reference targets have separate fore/hind hinges, dorsal/ventral patterns, earlier host-clear landing closure and distinct overlap at rest. Maps/body remain stylized; cadence and nectar feeding are not biologically validated."
      },
      "habitat": [
        "woodland-meadow"
      ],
      "provenance": {
        "models": [
          {
            "id": "butterfly-original-source",
            "label": "Original Blender-authored model",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
            "sha256": "cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
            "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
          }
        ],
        "references": [
          {
            "id": "butterfly-photo-1",
            "label": "Monarch dorsal wing pattern",
            "author": "Didier Descouens",
            "license": "CC BY-SA 3.0",
            "url": "https://commons.wikimedia.org/wiki/File:Danaus_plexippus_MHNT_femelle_dos.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "butterfly-photo-2",
            "label": "Common blue wing pattern",
            "author": "Tony Hisgett",
            "license": "CC BY 2.0",
            "url": "https://commons.wikimedia.org/wiki/File:Polyommatus_icarus_1.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "butterfly-photo-3",
            "label": "Cabbage white reference",
            "author": "W. Mike Howell / Alabama Butterfly Atlas",
            "license": "Copyrighted; reference only, no photograph redistribution",
            "url": "https://alabama.butterflyatlas.usf.edu/species/details/118/cabbage-white",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          }
        ],
        "textures": [
          {
            "id": "butterfly-original-maps",
            "label": "Original dorsal/ventral butterfly atlases",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:86c8bfe3aa2846fc4280bc59dcf1aafa97e046ae4bc13f8e907bf476837eb9df",
            "sha256": "86c8bfe3aa2846fc4280bc59dcf1aafa97e046ae4bc13f8e907bf476837eb9df",
            "origin": "original",
            "notes": "Species-informed painted/generated dorsal and ventral atlases. Reference-photo pixels are not included; marking arrangement remains an approximation."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {},
        "seededBounds": {},
        "method": "Approximate local scale uses the cabin 2 m door. Terrain distances are compressed for the diorama.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study.",
          "Three different variants use different neutral envelopes; no family-average body measurement is asserted."
        ]
      },
      "rig": {
        "id": "butterfly-four-wing-rig-v4",
        "type": "rigid-parts",
        "roles": [
          "body",
          "forewing-left",
          "hindwing-left",
          "forewing-right",
          "hindwing-right"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Flower rest",
            "description": "Flower rest",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Takeoff, hover and flutter",
            "description": "Takeoff, hover and flutter",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-3",
            "kind": "procedural",
            "label": "Land on the host flower",
            "description": "Land on the host flower",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Wind and rain change wing fold and shelter activity",
            "description": "Wind and rain change wing fold and shelter activity",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Season modulates visibility",
            "description": "Season modulates visibility",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "butterfly-gaits-1",
            "state": "implemented",
            "label": "Flower rest",
            "description": "Flower rest",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": []
          },
          {
            "id": "butterfly-gaits-2",
            "state": "implemented",
            "label": "Takeoff, hover and flutter",
            "description": "Takeoff, hover and flutter",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": []
          },
          {
            "id": "butterfly-gaits-3",
            "state": "implemented",
            "label": "Land on the host flower",
            "description": "Land on the host flower",
            "actionIds": [
              "gaits-3"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": []
          }
        ],
        "environment": [
          {
            "id": "butterfly-environment-1",
            "state": "implemented",
            "label": "Wind and rain change wing fold and shelter activity",
            "description": "Wind and rain change wing fold and shelter activity",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": []
          },
          {
            "id": "butterfly-environment-2",
            "state": "implemented",
            "label": "Season modulates visibility",
            "description": "Season modulates visibility",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": []
          }
        ],
        "neighbors": [
          {
            "id": "butterfly-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "butterfly-monarch",
          "family": "butterfly",
          "label": "Monarch",
          "assets": {
            "blender": {
              "artifactId": "sha256:cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
              "sha256": "cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
            },
            "export": {
              "contractId": "butterfly-monarch-export-v1",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:be5be34eaad80fb09a9ee86d262d710d754695d1a676bf832c891514651f262b",
                "sha256": "be5be34eaad80fb09a9ee86d262d710d754695d1a676bf832c891514651f262b",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Exact source recipe in the separately packaged editable source."
              },
              "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "butterfly-monarch-full-92301789",
                "path": "assets/wildlife/butterfly-fourwing-0-full-92301789.glb",
                "sha256": "923017895d19fb66195f6f36531d778fb0435022b1b4f8e97afcf60cb69cdf8d",
                "bytes": 496316,
                "purpose": "Selected WebGL export.",
                "rigId": "butterfly-four-wing-rig-v4",
                "exportContractId": "butterfly-monarch-export-v1",
                "triangles": 3680
              },
              {
                "id": "proxy",
                "payloadId": "butterfly-monarch-proxy-87412e3b",
                "path": "assets/wildlife/butterfly-fourwing-0-proxy-87412e3b.glb",
                "sha256": "87412e3b183f24784bbc169b4d74b5e99e0ebaa44c41386247a2cd2e4e6792fe",
                "bytes": 186700,
                "purpose": "Canvas fallback; visible macro simplification.",
                "rigId": "butterfly-four-wing-rig-v4",
                "exportContractId": "butterfly-monarch-export-v1",
                "triangles": 1552
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          },
          "identity": {
            "label": "Monarch",
            "taxon": {
              "name": "Danaus plexippus",
              "rank": "species-reference-target",
              "confidence": "low",
              "basis": "Species-informed dorsal/ventral pattern and four-wing overlap study; body/antennae and map detail remain simplified."
            }
          }
        },
        {
          "id": "butterfly-common-blue",
          "family": "butterfly",
          "label": "Common blue",
          "assets": {
            "blender": {
              "artifactId": "sha256:cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
              "sha256": "cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
            },
            "export": {
              "contractId": "butterfly-common-blue-export-v1",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:be5be34eaad80fb09a9ee86d262d710d754695d1a676bf832c891514651f262b",
                "sha256": "be5be34eaad80fb09a9ee86d262d710d754695d1a676bf832c891514651f262b",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Exact source recipe in the separately packaged editable source."
              },
              "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "butterfly-common-blue-full-ba8e275a",
                "path": "assets/wildlife/butterfly-fourwing-1-full-ba8e275a.glb",
                "sha256": "ba8e275a7cbbf52343b0db2a752b50d83296beb646724a34e001de433b3777b4",
                "bytes": 404588,
                "purpose": "Selected WebGL export.",
                "rigId": "butterfly-four-wing-rig-v4",
                "exportContractId": "butterfly-common-blue-export-v1",
                "triangles": 3824
              },
              {
                "id": "proxy",
                "payloadId": "butterfly-common-blue-proxy-7221d77a",
                "path": "assets/wildlife/butterfly-fourwing-1-proxy-7221d77a.glb",
                "sha256": "7221d77a8d8b95bfaeb713212a6f52fdf877a7e9503dc986c70738c5825e5db7",
                "bytes": 164396,
                "purpose": "Canvas fallback; visible macro simplification.",
                "rigId": "butterfly-four-wing-rig-v4",
                "exportContractId": "butterfly-common-blue-export-v1",
                "triangles": 1920
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          },
          "identity": {
            "label": "Common blue",
            "taxon": {
              "name": "Polyommatus icarus",
              "rank": "species-reference-target",
              "confidence": "low",
              "basis": "Species-informed dorsal/ventral pattern and four-wing overlap study; body/antennae and map detail remain simplified."
            }
          }
        },
        {
          "id": "butterfly-cabbage-white",
          "family": "butterfly",
          "label": "Cabbage white",
          "assets": {
            "blender": {
              "artifactId": "sha256:cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
              "sha256": "cbd1f6d3571647a59b2b6663df75f6c45bc4eeff2fdad3e4a10e2f3e4878f818",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
            },
            "export": {
              "contractId": "butterfly-cabbage-white-export-v1",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:be5be34eaad80fb09a9ee86d262d710d754695d1a676bf832c891514651f262b",
                "sha256": "be5be34eaad80fb09a9ee86d262d710d754695d1a676bf832c891514651f262b",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Exact source recipe in the separately packaged editable source."
              },
              "notes": "Four independently hinged fore/hind surfaces with distinct dorsal/ventral original painted maps. Monarch supports on four legs; reduced forepair stays tucked. Exact geometry profile4 and helper5 landing are separate contracts."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "butterfly-cabbage-white-full-d0cdda68",
                "path": "assets/wildlife/butterfly-fourwing-2-full-d0cdda68.glb",
                "sha256": "d0cdda684c49353ef730adf0bafc47834f9ea19f1632de231920f0ed2887d745",
                "bytes": 359576,
                "purpose": "Selected WebGL export.",
                "rigId": "butterfly-four-wing-rig-v4",
                "exportContractId": "butterfly-cabbage-white-export-v1",
                "triangles": 3892
              },
              {
                "id": "proxy",
                "payloadId": "butterfly-cabbage-white-proxy-0dfb73be",
                "path": "assets/wildlife/butterfly-fourwing-2-proxy-0dfb73be.glb",
                "sha256": "0dfb73beb824360925745af70637628313219364760bf87a7ec399a84fd682f2",
                "bytes": 145480,
                "purpose": "Canvas fallback; visible macro simplification.",
                "rigId": "butterfly-four-wing-rig-v4",
                "exportContractId": "butterfly-cabbage-white-export-v1",
                "triangles": 1876
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          },
          "identity": {
            "label": "Cabbage white",
            "taxon": {
              "name": "Pieris rapae",
              "rank": "species-reference-target",
              "confidence": "low",
              "basis": "Species-informed dorsal/ventral pattern and four-wing overlap study; body/antennae and map detail remain simplified."
            }
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Source, attribution and reference links are recorded. Photo pixels are not projected onto these models."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "butterfly-fourwing5-source-runtime"
          ],
          "reason": "Independent fore/hind overlap, dorsal/ventral faces and takeoff/landing stay attached in actual Three. Earlier landing closure clears the recorded clover intersection; full/proxy host sweeps remain hash-scoped technical evidence."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "The listed procedural patterns exist. Biological timing and full common-gait coverage remain a separate review."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "butterfly-published-technical"
          ],
          "reason": "Only the listed causal responses are implemented; no broader animal intelligence is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Published terrain, water and toe-contact checks cover their stated fixtures. Clearance against all host volumes and nearby solids has not been validated."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "butterfly-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Current landscape focus is available. Macro groundcover scale, contact light and proxy detail remain presentation limits."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "butterfly-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 9
        },
        "budgets": {
          "standardTriangles": 3892,
          "fallbackTriangles": 1920
        }
      }
    },
    {
      "id": "dragonfly-family",
      "family": "dragonfly",
      "identity": {
        "label": "Male emperor dragonfly study",
        "taxon": {
          "name": "Anax imperator",
          "rank": "species-reference-target",
          "confidence": "medium",
          "basis": "Adult male Emperor reference target, with normalized dorsal-photo comparisons guiding body, head, abdomen, wing outline and root spacing."
        },
        "notes": "Joined head/thorax/abdomen and four explicit wing hinges. Fine eyes, legs and veins remain simplified; flexible abdomen motion is not implemented."
      },
      "habitat": [
        "wetland-edge"
      ],
      "provenance": {
        "models": [
          {
            "id": "dragonfly-original-source",
            "label": "Original Blender-authored model",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:2aa8a13b21ad7c22439c8ca54badb4c807bb2cc938039adb77719e1e2e941683",
            "sha256": "2aa8a13b21ad7c22439c8ca54badb4c807bb2cc938039adb77719e1e2e941683",
            "notes": "Editable source and reproducible export recipe are tracked separately."
          }
        ],
        "references": [
          {
            "id": "dragonfly-photo-1",
            "label": "Emperor dragonfly",
            "author": "Andreas Trepte",
            "license": "CC BY-SA2.5",
            "url": "https://commons.wikimedia.org/wiki/File:Emperor_dragonfly.jpg",
            "notes": "Initial morphology reference; bent oblique pose does not determine width/span ratios."
          },
          {
            "id": "dragonfly-photo-2",
            "label": "Anax imperator qtl2",
            "author": "Quartl",
            "license": "CC BY3.0 selected from dual license",
            "url": "https://commons.wikimedia.org/wiki/File:Anax_imperator_qtl2.jpg",
            "notes": "Near-dorsal adult male normalized proportions, wing-root spacing and fore/hind outline. Reference photograph is not embedded in the GLB."
          },
          {
            "id": "dragonfly-photo-3",
            "label": "Male Emperor dorsal photograph",
            "author": "Steve Plume / British Dragonfly Society species page",
            "license": "Copyright, reference-only; no redistribution",
            "url": "https://british-dragonflies.org.uk/species/emperor-dragonfly/",
            "notes": "Second independent near-dorsal ratio estimate; photo is excluded from source/evidence deliverable."
          }
        ],
        "textures": [
          {
            "id": "dragonfly-original-maps",
            "label": "Original procedural color maps",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:82d811693c720e9110e2145b6a44581cc7184c54c36e05040822f31122f63267",
            "sha256": "82d811693c720e9110e2145b6a44581cc7184c54c36e05040822f31122f63267",
            "origin": "procedural",
            "notes": "No reference-photo pixels are included."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "neutral_width": 0.09374017389411601,
          "neutral_height": 0.01297543637263469,
          "neutral_depth": 0.07036707085421962
        },
        "seededBounds": {
          "neutral_width": [
            0.08061654954893976,
            0.10873860171717457
          ],
          "neutral_height": [
            0.011158875280465833,
            0.01505150619225624
          ],
          "neutral_depth": [
            0.06051568093462887,
            0.08162580219089474
          ]
        },
        "method": "Frozen v6 neutral model envelope including appendages, with existing uniform .06 scale at .1755 world units/m and seeded .86–1.16 variation.",
        "limitations": [
          "Envelope dimensions include wings and are not biological body-length measurements.",
          "Hover/dart wing motion is an engineering pattern; exact species wingbeat and flexible abdomen motion remain unverified."
        ]
      },
      "rig": {
        "id": "dragonfly-selected-rig-v2",
        "type": "rigid-parts",
        "roles": [
          "joined-body",
          "four-wing-hinges"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Hover and dart between four route points",
            "description": "Hover and dart between four route points",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Wingbeat",
            "description": "Wingbeat",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Weather changes wing amplitude, pitch and activity",
            "description": "Weather changes wing amplitude, pitch and activity",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "dragonfly-gaits-1",
            "state": "implemented",
            "label": "Hover and dart between four route points",
            "description": "Hover and dart between four route points",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "dragonfly6-surface"
            ]
          },
          {
            "id": "dragonfly-gaits-2",
            "state": "implemented",
            "label": "Wingbeat",
            "description": "Wingbeat",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "dragonfly6-surface"
            ]
          }
        ],
        "environment": [
          {
            "id": "dragonfly-environment-1",
            "state": "implemented",
            "label": "Weather changes wing amplitude, pitch and activity",
            "description": "Weather changes wing amplitude, pitch and activity",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "dragonfly6-surface"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "dragonfly-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "dragonfly-selected",
          "family": "dragonfly",
          "label": "Emperor dragonfly",
          "assets": {
            "blender": {
              "artifactId": "sha256:2aa8a13b21ad7c22439c8ca54badb4c807bb2cc938039adb77719e1e2e941683",
              "sha256": "2aa8a13b21ad7c22439c8ca54badb4c807bb2cc938039adb77719e1e2e941683",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
            },
            "export": {
              "contractId": "dragonfly-selected-export-v2",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:9863c15b4d19f3653891df9dc2fea3e9003570d2ec5cdc890531d57753566d62",
                "sha256": "9863c15b4d19f3653891df9dc2fea3e9003570d2ec5cdc890531d57753566d62",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
              },
              "notes": "Exact v6 role pivots and bind matrices are validated against loaded geometry. Body/wing proportions use two separately inspected dorsal-photo comparisons."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "dragonfly-selected-full-1820dc70",
                "path": "assets/wildlife/dragonfly-study6-1820dc70.glb",
                "sha256": "1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50",
                "bytes": 138432,
                "purpose": "Same compact 2,488-triangle source for WebGL and Canvas; fallback cost and visibility are measured in the selected scene.",
                "rigId": "dragonfly-selected-rig-v2",
                "exportContractId": "dragonfly-selected-export-v2",
                "triangles": 2488
              },
              {
                "id": "proxy",
                "payloadId": "dragonfly-selected-proxy-1820dc70",
                "path": "assets/wildlife/dragonfly-study6-1820dc70.glb",
                "sha256": "1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50",
                "bytes": 138432,
                "purpose": "Same compact 2,488-triangle source for WebGL and Canvas; fallback cost and visibility are measured in the selected scene.",
                "rigId": "dragonfly-selected-rig-v2",
                "exportContractId": "dragonfly-selected-export-v2",
                "triangles": 2488
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Source, attribution and reference links are recorded. Photo pixels are not projected onto these models."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "dragonfly6-surface"
          ],
          "reason": "Two dorsal-photo comparisons support the revised joined body, wing roots and fore/hind membrane outlines. Native shape/material proof passes; fine face/leg/vein detail remains simplified."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "dragonfly6-surface"
          ],
          "reason": "Four authored hinges retain attached membranes through the demonstrated hover and dart. Wingbeat and abdomen flex are not biologically validated."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "dragonfly-published-technical"
          ],
          "reason": "Only the listed causal responses are implemented; no broader animal intelligence is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "dragonfly6-surface"
          ],
          "reason": "Fresh actual transformed v6 vertices clear rendered terrain, water and case in the sampled corpus. Solid prop and other-animal collisions remain outside this scope."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "dragonfly6-surface",
            "dragonfly-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "dragonfly6-surface",
            "dragonfly-normal-selection-v26"
          ],
          "reason": "Normal selected hover and dart views retain distinct membranes. Canvas area-prefiltering restores major veins at minified footprints; fine cross-veins soften."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "dragonfly-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 6
        },
        "budgets": {
          "standardTriangles": 2488,
          "fallbackTriangles": 2488
        }
      }
    },
    {
      "id": "firefly-family",
      "family": "firefly",
      "identity": {
        "label": "Male common eastern firefly",
        "taxon": {
          "name": "Photinus pyralis",
          "rank": "species-reference-target",
          "confidence": "medium",
          "basis": "Photo-guided male anatomy with two ventral lantern plates, dark dorsal abdomen and explicit yellow emission; simplified detail remains."
        },
        "notes": "Flying residents are adult male display exemplars targeting Photinus pyralis. Female replies, mating success and population synchrony are not implemented."
      },
      "habitat": [
        "dusk-meadow"
      ],
      "provenance": {
        "models": [
          {
            "id": "firefly-original-source",
            "label": "Original Blender-authored model",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:ba541491a4774ba733c04e12a1cab2c151ecf18697c8242fc4ae8f82e5fc6aeb",
            "sha256": "ba541491a4774ba733c04e12a1cab2c151ecf18697c8242fc4ae8f82e5fc6aeb",
            "notes": "Editable source and reproducible export recipe are tracked separately."
          }
        ],
        "references": [
          {
            "id": "firefly-photo-1",
            "label": "Eastern firefly reference",
            "author": "art farmer",
            "license": "CC BY-SA 2.0",
            "url": "https://commons.wikimedia.org/wiki/File:Photinus_pyralis_Firefly.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "firefly-timing-npn",
            "label": "Photinus pyralis male flash timing",
            "author": "USA National Phenology Network",
            "license": "Linked reference; content not bundled",
            "url": "https://mynpn.usanpn.org/npnapps/species/Photinus/pyralis",
            "notes": "Male single yellow flash lasting 0.6–0.8 s, repeated every 5–7 s. Female reply is outside this implementation."
          },
          {
            "id": "firefly-flight-nps",
            "label": "Firefly flash patterns",
            "author": "National Park Service",
            "license": "Linked reference; content not bundled",
            "url": "https://home.nps.gov/grsm/learn/nature/firefly-flash-patterns.htm",
            "notes": "Male upward sustained yellow J-like display before full darkness. Park-local clock times are not used as a universal schedule."
          }
        ],
        "textures": [
          {
            "id": "firefly-original-maps",
            "label": "Original procedural color maps",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:5c9a09d3129380d89d3ff3ab908facec49276571f650b4cb1eb21aa8cd63ec9a",
            "sha256": "5c9a09d3129380d89d3ff3ab908facec49276571f650b4cb1eb21aa8cd63ec9a",
            "origin": "procedural",
            "notes": "No reference-photo pixels are included."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "body_length_excluding_antennae": 0.01292
        },
        "seededBounds": {
          "body_length_excluding_antennae": [
            0.01292,
            0.01292
          ]
        },
        "method": "Metre-authored adult male body measurement; scene wrapper is 0.1755 world units/m. Wings and antennae excluded. All 48 display residents use this fixed physical size.",
        "limitations": [
          "Reference-guided model, not a biological specimen measurement.",
          "Wing/antenna extents vary with pose."
        ]
      },
      "rig": {
        "id": "firefly-selected-rig-v2",
        "type": "rigid-parts",
        "roles": [
          "firefly_body",
          "firefly_elytron_l",
          "firefly_wing_l",
          "firefly_elytron_r",
          "firefly_wing_r",
          "firefly_lantern"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Seeded male display flight",
            "description": "Independent absolute-time male flash and bounded rising display phrase.",
            "sourceIds": [
              "runtime-authored-wildlife"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Wing and elytron motion",
            "description": "Wing and elytron motion",
            "sourceIds": [
              "runtime-authored-wildlife"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Dusk and weather modulate glow",
            "description": "Dusk and weather modulate glow",
            "sourceIds": [
              "runtime-authored-wildlife"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Whole body clears terrain and water crest",
            "description": "Whole body clears terrain and water crest",
            "sourceIds": [
              "runtime-authored-wildlife"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "firefly-gaits-1",
            "state": "implemented",
            "label": "Seeded male display flight",
            "description": "A bounded upward J-like display is added to individual flight, with a smooth return while dark. Absolute simulation time drives independent phases; dimensions are engineering estimates.",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-authored-wildlife"
            ],
            "evidenceIds": [
              "firefly04-runtime"
            ]
          },
          {
            "id": "firefly-gaits-2",
            "state": "implemented",
            "label": "Wing and elytron motion",
            "description": "Wing and elytron motion",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-authored-wildlife"
            ],
            "evidenceIds": [
              "firefly04-runtime"
            ]
          }
        ],
        "environment": [
          {
            "id": "firefly-environment-1",
            "state": "implemented",
            "label": "Dusk and weather modulate glow",
            "description": "Each adult male has one smooth flash lasting 0.6–0.8 s every 5–7 s. Dusk, winter and rain gate emission separately from visible body alpha.",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-authored-wildlife"
            ],
            "evidenceIds": [
              "firefly04-runtime"
            ]
          },
          {
            "id": "firefly-environment-2",
            "state": "implemented",
            "label": "Whole body clears terrain and water crest",
            "description": "Whole body clears terrain and water crest",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-authored-wildlife"
            ],
            "evidenceIds": [
              "firefly04-surface"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "firefly-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "firefly-selected",
          "family": "firefly",
          "label": "Common eastern firefly",
          "assets": {
            "blender": {
              "artifactId": "sha256:ba541491a4774ba733c04e12a1cab2c151ecf18697c8242fc4ae8f82e5fc6aeb",
              "sha256": "ba541491a4774ba733c04e12a1cab2c151ecf18697c8242fc4ae8f82e5fc6aeb",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
            },
            "export": {
              "contractId": "firefly-selected-export-v2",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:52d44707e0d632d933cabceafee1cfa16f4900e9d6364bfbd9b84a08201d655a",
                "sha256": "52d44707e0d632d933cabceafee1cfa16f4900e9d6364bfbd9b84a08201d655a",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
              },
              "notes": "Official dense glTF export; decoded geometry, morphs, hinges, images and materials equal the reviewed04 source. Compact payload selected for ordinary WebGL and Canvas after a measured full/proxy comparison."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "firefly-selected-full-fc262859",
                "path": "assets/wildlife/firefly-male-fc262859.glb",
                "sha256": "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5",
                "bytes": 192084,
                "purpose": "Shared compact04 payload for ordinary WebGL and Canvas. The 6,892-triangle full source remains an optional unselected authoring asset; actual Inspect comparison did not justify population-wide cost.",
                "rigId": "firefly-selected-rig-v2",
                "exportContractId": "firefly-selected-export-v2",
                "triangles": 2372
              },
              {
                "id": "proxy",
                "payloadId": "firefly-selected-proxy-fc262859",
                "path": "assets/wildlife/firefly-male-fc262859.glb",
                "sha256": "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5",
                "bytes": 192084,
                "purpose": "Shared compact04 payload for ordinary WebGL and Canvas. The 6,892-triangle full source remains an optional unselected authoring asset; actual Inspect comparison did not justify population-wide cost.",
                "rigId": "firefly-selected-rig-v2",
                "exportContractId": "firefly-selected-export-v2",
                "triangles": 2372
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Source, attribution and reference links are recorded. Photo pixels are not projected onto these models."
        },
        "anatomy": {
          "state": "validated",
          "evidenceIds": [
            "firefly04-anatomy"
          ],
          "reason": "Photo-guided adult male body and paired yellow ventral plates pass the bounded actual-scene surface/material check.",
          "validation": {
            "sourceHashes": {
              "blender": "ba541491a4774ba733c04e12a1cab2c151ecf18697c8242fc4ae8f82e5fc6aeb",
              "export-recipe": "52d44707e0d632d933cabceafee1cfa16f4900e9d6364bfbd9b84a08201d655a"
            },
            "assetHashes": [
              "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"
            ],
            "renderer": "webgl",
            "lods": [
              "full",
              "proxy"
            ],
            "variantIds": [
              "firefly-selected"
            ],
            "fixtureIds": [
              "firefly04-proxy-dark-flash-dark"
            ],
            "date": "2026-10-11",
            "scope": "Bounded photo-guided male surface/material gate: dark body, separate covers, curved membranes and two yellow ventral lantern plates under actual scene light.",
            "limitations": [
              "Pronotum, leg joints and membrane veins remain simplified.",
              "This visual scope does not establish courtship, flight aerodynamics or wrapped substrate contacts.",
              "The same compact payload is selected for both runtime modes; Canvas appearance requires its own final selected-scene check."
            ]
          }
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "firefly04-runtime"
          ],
          "reason": "Independent male flash periods of 5–7 s and pulse durations of 0.6–0.8 s pass exact-time and temporal native tests. Route-wide physical display is only a few pixels; the J-like path remains an engineering approximation."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "firefly04-runtime"
          ],
          "reason": "Only the listed causal responses are implemented; no broader animal intelligence is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "firefly04-surface"
          ],
          "reason": "Fresh transformed full/proxy vertex sweep clears terrain, water crest and case. Private rock/prop intersection and substrate landing are not covered."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "firefly04-runtime",
            "firefly-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "firefly04-runtime"
          ],
          "reason": "Yellow ventral flash is visible while the dark body persists. The compact mesh is chosen after the full mesh added 541,440 submitted triangles with little visible Inspect benefit; final aggregate scene cost and Canvas appearance remain to verify."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "firefly-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 48
        },
        "budgets": {
          "standardTriangles": 2372,
          "fallbackTriangles": 2372
        }
      }
    },
    {
      "id": "robin-family",
      "family": "robin",
      "identity": {
        "label": "European robin study",
        "taxon": {
          "name": "Erithacus rubecula",
          "rank": "species-reference-target",
          "confidence": "medium",
          "basis": "Adult European robin photo-informed body/plumage, with a continuous original torso and articulated source-derived wings/toes. Simplified face/feather detail and inferred unseen depth remain."
        },
        "notes": "Perch, takeoff, flight and refold use a shared 65-joint rig. Wrapped toe grip and precise ecological flight-path realism remain limited."
      },
      "habitat": [
        "woodland-meadow"
      ],
      "provenance": {
        "models": [
          {
            "id": "robin-original-source",
            "label": "Original robin body with CC0 rig/appendage derivatives",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:eaf0bdec397f77f1ee192d26f916a1168e96e688388055d5e0d9ae7b69b5d820",
            "sha256": "eaf0bdec397f77f1ee192d26f916a1168e96e688388055d5e0d9ae7b69b5d820",
            "notes": "Independent body, eyes, bill and tail; wing/toe geometry and rig derive from pistachio’s Yellow-billed Shrike under CC0."
          },
          {
            "id": "robin-shrike-base",
            "label": "Yellow-billed Shrike rig and appendage source",
            "author": "pistachio",
            "license": "CC0",
            "url": "https://opengameart.org/content/bird-yellow-billed-shrike",
            "notes": "Wing/toe geometry, rig and adapted feather atlas derivatives. The model is reshaped as a European robin; it is not a recolored shrike. Upstream atlas origins were not independently audited."
          }
        ],
        "references": [
          {
            "id": "robin-photo-1",
            "label": "European robin profile",
            "author": "C-M",
            "license": "CC BY-SA 4.0",
            "url": "https://commons.wikimedia.org/wiki/File:Erithacus_rubecula_profile.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "robin-rspb",
            "label": "Robin perched anatomy",
            "author": "RSPB",
            "license": "Linked reference; image/text not bundled",
            "url": "https://www.rspb.org.uk/birds-and-wildlife/robin",
            "notes": "Copyright; reference only, image not bundled."
          },
          {
            "id": "robin-flight-photo",
            "label": "Garden robin flight",
            "author": "John Crabb",
            "license": "Linked reference; image/text not bundled",
            "url": "https://johncrabbwildlifeimages.blogspot.com/2015/01/back-to-garden-birds-in-flight.html",
            "notes": "Copyright; reference only, image not bundled."
          },
          {
            "id": "robin-size-guide",
            "label": "Robin physical guide",
            "author": "The Wildlife Trusts",
            "license": "Linked reference; image/text not bundled",
            "url": "https://www.wildlifetrusts.org/wildlife-explorer/birds/thrushes-chats-flycatchers-starling-dipper-and-wren/robin",
            "notes": "Species guide: length 14 cm and wingspan 21 cm; model measurements are pose-specific."
          },
          {
            "id": "robin-wingbeat-study",
            "label": "Measured robin wingbeat",
            "author": "Hedenström et al., 2006",
            "license": "Linked reference; image/text not bundled",
            "url": "https://bpb-us-w1.wpmucdn.com/sites.usc.edu/dist/4/81/files/2022/06/HRS_JRSI_06.pdf",
            "notes": "One bird in continuous 4–9 m/s tunnel flight: 14.1–15.5 Hz and downstroke fraction 0.44–0.49. Application branch flights differ; no universal rate claim."
          }
        ],
        "textures": [
          {
            "id": "robin-original-maps",
            "label": "Original robin body coat",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:69e7aae74d5185dd6f5b650d213159ebc9091f8596d2153c439125b802f7a79e",
            "sha256": "69e7aae74d5185dd6f5b650d213159ebc9091f8596d2153c439125b802f7a79e",
            "origin": "procedural",
            "notes": "Independent generated body coat; no robin reference-photo pixels copied."
          },
          {
            "id": "robin-inherited-feather-atlas",
            "label": "Adapted source feather atlas",
            "author": "pistachio",
            "license": "CC0 as supplied with the source model",
            "url": "https://opengameart.org/content/bird-yellow-billed-shrike",
            "origin": "inherited",
            "notes": "Source feather atlas is adapted for the appendages. Upstream texture origin was not independently audited."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "perched_width": 0.04638,
          "perched_height": 0.08481,
          "perched_depth": 0.126,
          "bill_tail_point_distance": 0.13282,
          "spread_wingspan": 0.20975
        },
        "seededBounds": {
          "perched_width": [
            0.0398868,
            0.053800799999999996
          ],
          "perched_height": [
            0.07293659999999999,
            0.09837959999999998
          ],
          "perched_depth": [
            0.10836,
            0.14615999999999998
          ],
          "bill_tail_point_distance": [
            0.1142252,
            0.1540712
          ],
          "spread_wingspan": [
            0.180385,
            0.24330999999999997
          ]
        },
        "method": "Frozen full10 metre-space pose measurements, uniformly scaled by the existing seeded 0.86–1.16 size factor at 0.1755 world units/m.",
        "limitations": [
          "Pose extents differ from biological field length measurements.",
          "The anatomy is photo-informed, with inferred hidden depth and simplified feathers."
        ]
      },
      "rig": {
        "id": "robin-selected-rig-v2",
        "type": "skinned",
        "roles": [
          "root",
          "body-spine-chest",
          "neck-head-bill",
          "shoulder-elbow-wrist-primary",
          "three-segment-legs",
          "independent-toes",
          "folded-wing-tail-morph"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Perch, look and peck",
            "description": "Perch, look and peck",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Takeoff and flight",
            "description": "Takeoff and flight",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-3",
            "kind": "procedural",
            "label": "Land and fold wings",
            "description": "Land and fold wings",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Weather changes held head posture",
            "description": "Rain, wind and snow shelter the head and reduce looking while fixed route contacts are preserved. A full-body crouch is not implemented on this rig.",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Season modulates activity",
            "description": "Season modulates activity",
            "sourceIds": [
              "runtime-biodiversity"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "robin-gaits-1",
            "state": "implemented",
            "label": "Perch, look and peck",
            "description": "Perch, look and peck",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-biodiversity",
              "runtime-original-bird-study"
            ],
            "evidenceIds": [
              "robin10-native"
            ]
          },
          {
            "id": "robin-gaits-2",
            "state": "implemented",
            "label": "Takeoff and flight",
            "description": "Takeoff and flight",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-biodiversity",
              "runtime-original-bird-study"
            ],
            "evidenceIds": [
              "robin10-native"
            ]
          },
          {
            "id": "robin-gaits-3",
            "state": "implemented",
            "label": "Land and fold wings",
            "description": "Land and fold wings",
            "actionIds": [
              "gaits-3"
            ],
            "sourceIds": [
              "runtime-biodiversity",
              "runtime-original-bird-study"
            ],
            "evidenceIds": [
              "robin10-native"
            ]
          }
        ],
        "environment": [
          {
            "id": "robin-environment-1",
            "state": "implemented",
            "label": "Weather changes held head posture",
            "description": "Rain, wind and snow shelter the head and reduce looking while fixed route contacts are preserved. A full-body crouch is not implemented on this rig.",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-biodiversity",
              "runtime-original-bird-study"
            ],
            "evidenceIds": []
          },
          {
            "id": "robin-environment-2",
            "state": "implemented",
            "label": "Season modulates activity",
            "description": "Season modulates activity",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-biodiversity"
            ],
            "evidenceIds": []
          }
        ],
        "neighbors": [
          {
            "id": "robin-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "robin-selected",
          "family": "robin",
          "label": "European robin",
          "assets": {
            "blender": {
              "artifactId": "sha256:eaf0bdec397f77f1ee192d26f916a1168e96e688388055d5e0d9ae7b69b5d820",
              "sha256": "eaf0bdec397f77f1ee192d26f916a1168e96e688388055d5e0d9ae7b69b5d820",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
            },
            "export": {
              "contractId": "robin-selected-export-v2",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:003ca5137fb3164d42759af2bc7cd622e17250515af65507c3ac858ad27a9152",
                "sha256": "003ca5137fb3164d42759af2bc7cd622e17250515af65507c3ac858ad27a9152",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
              },
              "notes": "Exact core10 full and same-rig proxy. Required bind pivots/inverse binds and authored local-axis wing/tuck guides are verified at the adapter boundary."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "robin-selected-full-54607a09",
                "path": "assets/wildlife/robin-core10-54607a09.glb",
                "sha256": "54607a09f39df438c4faf706cacf9808a936efbc6b7ffda9008335a14f906053",
                "bytes": 2976488,
                "purpose": "Primary close-quality mesh.",
                "rigId": "robin-selected-rig-v2",
                "exportContractId": "robin-selected-export-v2",
                "triangles": 15976
              },
              {
                "id": "proxy",
                "payloadId": "robin-selected-proxy-40e30dc8",
                "path": "assets/wildlife/robin-core10-proxy-40e30dc8.glb",
                "sha256": "40e30dc808a66ec86375abd5f5661606c500cc77ed83f06fde41e153acec3758",
                "bytes": 621464,
                "purpose": "Same-rig Canvas/distant derivative; visible feather and eye faceting at macro scale.",
                "rigId": "robin-selected-rig-v2",
                "exportContractId": "robin-selected-export-v2",
                "triangles": 2917
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Source, attribution and reference links are recorded. Photo pixels are not projected onto these models."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "robin10-native",
            "robin-normal-selection-v26"
          ],
          "reason": "Continuous body, compact flank wings and face are a bounded photo-guided improvement. Normal full/proxy native surfaces and Canvas views pass; fine plumage, face detail and wrapped grip remain simplified."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "robin10-native"
          ],
          "reason": "Absolute-time articulated wings and three-segment tucked legs pass the sampled 60 fps flight gate. Seeded 14.1–15.5 Hz derives from one continuous-flight study; branch maneuvers remain an approximation."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "robin10-native"
          ],
          "reason": "Weather changes held head posture and seasonal activity. Neighbor courtship/flocking and a full-body shelter crouch are not implemented."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "robin10-host",
            "robin10-proxy-host"
          ],
          "reason": "Shared scenery-aware hosts and routes resolve the old trunk/fruit embedding and occupied-twig overlap. Both default robins are present. Full/proxy own-twig sweeps pass with nearest-toe distances under 1.9 mm; fully wrapped grip remains provisional."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "robin10-lifecycle",
            "robin-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "robin10-native"
          ],
          "reason": "Both default Inspect perches are readable on separate continuing twigs. Angular branches and oversized faceted leaves/berries remain environment limitations."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "robin-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 2
        },
        "budgets": {
          "standardTriangles": 15976,
          "fallbackTriangles": 2917
        }
      }
    },
    {
      "id": "wren-family",
      "family": "wren",
      "identity": {
        "label": "Photo-informed Eurasian wren",
        "taxon": {
          "name": "Troglodytes troglodytes",
          "rank": "species-reference-target",
          "confidence": "low",
          "basis": "Reference target recorded by the artist; species-level anatomical accuracy remains under review."
        },
        "notes": "Fitted continuous body, low head/chest, fine bill and compact cocked tail. Rest/look, short flight, folded return and weather posture are implemented. Fine face and feather detail remain simplified."
      },
      "habitat": [
        "woodland-meadow"
      ],
      "provenance": {
        "models": [
          {
            "id": "wren-source-cage",
            "label": "CC0 articulated wing/toe and skeleton base",
            "author": "pistachio; original body and species adaptation by Weatherglass",
            "license": "CC0 source; original project additions",
            "url": "https://opengameart.org/content/bird-yellow-billed-shrike",
            "notes": "Only wing/toe geometry, skeleton and adapted feather atlas remain from the source. Body, bill, eyes, tail and coat are independently constructed. Upstream feather-map origins were not independently audited."
          }
        ],
        "references": [
          {
            "id": "wren-photo-1",
            "label": "Eurasian wren form",
            "author": "Alexis Lours",
            "license": "CC BY 4.0",
            "url": "https://commons.wikimedia.org/wiki/File:Eurasian_wren_(Troglodytes_troglodytes).jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          }
        ],
        "textures": [
          {
            "id": "wren-original-maps",
            "label": "Original wren body coat",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:f3e51a724c897284fc12909503d92de86fd6c3dfae7b2cdaed39d870d8734ee7",
            "sha256": "f3e51a724c897284fc12909503d92de86fd6c3dfae7b2cdaed39d870d8734ee7",
            "origin": "procedural",
            "notes": "Original procedural body markings. No reference-photo pixels copied."
          },
          {
            "id": "wren-inherited-feather-atlas",
            "label": "Adapted CC0 source feather atlas",
            "author": "pistachio source asset; Weatherglass adaptation",
            "license": "CC0 source asset declaration",
            "url": "https://opengameart.org/content/bird-yellow-billed-shrike",
            "origin": "inherited",
            "notes": "Inherited feather-map origin is recorded without an independent upstream pixel audit. Reference-photo pixels were not copied."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "bill_tail_longitudinal_perched": 0.0915,
          "spread_wingspan": 0.15
        },
        "seededBounds": {},
        "method": "Pose-labelled canonical metre measurements of the selected wren04 export, compared with the approximate 10 cm length / 15 cm span species guide. Seeded uniform variation is applied once.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study.",
          "Per-resident seeded size and animated extents must be measured from the actual posed skin."
        ]
      },
      "rig": {
        "id": "wren-selected-rig-v2",
        "type": "skinned",
        "roles": [
          "body-head-neck",
          "four-wing-joints-per-side",
          "independent-tail",
          "three-leg-segments-per-side",
          "toe-chains"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Perch, scan, takeoff, short flight and folded landing",
            "description": "Absolute-time articulated wings and compact foot tuck, with earlier departure deployment and later arrival closure. Provisional 18.3–19.7 Hz cadence is an allometric engineering inference, not a measured wren rate.",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Takeoff and flight",
            "description": "Takeoff and flight",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-3",
            "kind": "procedural",
            "label": "Land and fold wings",
            "description": "Land and fold wings",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Wind and rain change perched crouch and wing posture",
            "description": "Wind and rain change perched crouch and wing posture",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Season modulates activity",
            "description": "Season modulates activity",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "wren-gaits-1",
            "state": "implemented",
            "label": "Perch, scan, takeoff, short flight and folded landing",
            "description": "Absolute-time articulated wings and compact foot tuck, with earlier departure deployment and later arrival closure. Provisional 18.3–19.7 Hz cadence is an allometric engineering inference, not a measured wren rate.",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "wren-grounded-scene-handoff"
            ]
          },
          {
            "id": "wren-gaits-2",
            "state": "implemented",
            "label": "Takeoff and flight",
            "description": "Takeoff and flight",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "wren-grounded-scene-handoff"
            ]
          },
          {
            "id": "wren-gaits-3",
            "state": "implemented",
            "label": "Land and fold wings",
            "description": "Land and fold wings",
            "actionIds": [
              "gaits-3"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "wren-grounded-scene-handoff"
            ]
          }
        ],
        "environment": [
          {
            "id": "wren-environment-1",
            "state": "implemented",
            "label": "Wind and rain change perched crouch and wing posture",
            "description": "Wind and rain change perched crouch and wing posture",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "wren-grounded-scene-handoff"
            ]
          },
          {
            "id": "wren-environment-2",
            "state": "implemented",
            "label": "Season modulates activity",
            "description": "Season modulates activity",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "wren-grounded-scene-handoff"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "wren-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "wren-selected",
          "family": "wren",
          "label": "Eurasian wren",
          "assets": {
            "blender": {
              "artifactId": "sha256:fb69f8a7b30ef0f2c75584b1fc0a5e9068a903b2c2fdedfdf4a5b3dc1e918ce1",
              "sha256": "fb69f8a7b30ef0f2c75584b1fc0a5e9068a903b2c2fdedfdf4a5b3dc1e918ce1",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable source and exact rebuild recipe are retained in the separate source handoff."
            },
            "export": {
              "contractId": "wren-selected-export-v2",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:f3e51a724c897284fc12909503d92de86fd6c3dfae7b2cdaed39d870d8734ee7",
                "sha256": "f3e51a724c897284fc12909503d92de86fd6c3dfae7b2cdaed39d870d8734ee7",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Editable source and exact rebuild recipe are retained in the separate source handoff."
              },
              "notes": "Fitted 65-joint wren rig, exported bind matrices, actual toe samples and species-specific local wing/tuck guides. Full/proxy rebuilds are byte-identical to their selected hashes."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "wren-selected-full-f67060c8",
                "path": "assets/wildlife/wren-core04-f67060c8.glb",
                "sha256": "f67060c85c3f63a6ecf86bbc85dcf138aa9b81bcfc7c2f2c29c1df9dab0ab622",
                "bytes": 3511300,
                "purpose": "Primary WebGL close detail.",
                "rigId": "wren-selected-rig-v2",
                "exportContractId": "wren-selected-export-v2",
                "triangles": 15976
              },
              {
                "id": "proxy",
                "payloadId": "wren-selected-proxy-283b0e6e",
                "path": "assets/wildlife/wren-core04-proxy-283b0e6e.glb",
                "sha256": "283b0e6e7ea28dc4490caf68781a0656fdd10bc7d5b3e982e46a3d8c7b2389c6",
                "bytes": 654120,
                "purpose": "Canvas/distant same-rig derivative; eye and feather facets remain visible at macro scale.",
                "rigId": "wren-selected-rig-v2",
                "exportContractId": "wren-selected-export-v2",
                "triangles": 2917
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff"
          ],
          "reason": "CC0 source derivatives, original additions and reference-only photographs are documented; upstream atlas pixel origin remains unverified."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff"
          ],
          "reason": "Reference-guided head/chest, bill and cocked-tail proportions passed bounded source and scene review. Fine facial and feather detail remain simplified."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff"
          ],
          "reason": "Perch, takeoff, active stroke, foot tuck and refold passed ordered native and Canvas review. The approximately 19 Hz rate is provisional cross-species allometry, not measured wren cadence."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff"
          ],
          "reason": "Weather/activity changes and resting head response are implemented. No courtship, song audio or species-specific neighbor response is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff"
          ],
          "reason": "Both birds are retained across all four reviewed seeds with real shrub or grounded twig supports. Sampled whole skin, stem/berry/trunk and resident reservations pass; toe grip is proximity, not certified claw wrapping."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff",
            "wren-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "wren-grounded-scene-handoff"
          ],
          "reason": "Recovered wrens are readable on real tapered ground-supported forks; all departure/return frames render after the bark UV correction. The wood remains angular and simple, with partial natural grass occlusion."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "wren-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 2
        },
        "budgets": {
          "standardTriangles": 15976,
          "fallbackTriangles": 2917
        }
      }
    },
    {
      "id": "swallow-family",
      "family": "swallow",
      "identity": {
        "label": "Photo-informed adult barn swallow",
        "taxon": {
          "name": "Hirundo rustica rustica",
          "rank": "species-reference-target",
          "confidence": "low",
          "basis": "Reference target recorded by the artist; species-level anatomical accuracy remains under review."
        },
        "notes": "European adult phenotype, sex unspecified. Continuous chest, long pointed articulated wings and forked tail. Daytime twig rest, departure, flap/interrupted upstroke/glide, arrival and refold are implemented. Facial surface and toe treatment remain simplified."
      },
      "habitat": [
        "open-air"
      ],
      "provenance": {
        "models": [
          {
            "id": "swallow-source-cage",
            "label": "CC0 wing/toe and skeleton base with independently fitted swallow core",
            "author": "pistachio; species adaptation by Weatherglass",
            "license": "CC0 source; original project additions",
            "url": "https://opengameart.org/content/bird-yellow-billed-shrike",
            "notes": "Wing/toe geometry, skeleton and adapted feather atlas derive from the source. Body, bill, eyes, tail and coat are independently constructed; upstream atlas pixel origin remains unaudited."
          }
        ],
        "references": [
          {
            "id": "swallow-photo-1",
            "label": "Barn swallow flight",
            "author": "Giles Laurent",
            "license": "CC BY-SA 4.0",
            "url": "https://commons.wikimedia.org/wiki/File:080_Wild_Barn_swallow_in_flight_at_Pfyn-Finges_Photo_by_Giles_Laurent.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "swallow-photo-2",
            "label": "Supporting flight silhouette",
            "author": "Dori",
            "license": "CC BY-SA 3.0 US",
            "url": "https://commons.wikimedia.org/wiki/File:Hirundo_rustica_6077.jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "swallow-daytime-branch",
            "label": "Adult barn swallow resting on a woody twig",
            "author": "Andy Morffew",
            "license": "CC BY 2.0",
            "url": "https://commons.wikimedia.org/wiki/File:Barn_Swallow_(14543889672).jpg",
            "notes": "Reference-only support-use evidence; does not establish overnight roost or measured landing timing."
          },
          {
            "id": "swallow-flight-kinematics",
            "label": "Adult male flight kinematics, Park et al. 2001",
            "author": "Park, Rosén and Hedenström",
            "license": "Reference-only primary research",
            "url": "https://doi.org/10.1242/jeb.204.15.2741",
            "notes": "Two adult males in 4–14 m/s wind-tunnel conditions. The implemented 7–8 Hz active cycle and qualitative pause/glide controller are bounded engineering choices, not a species-wide fixed rate."
          }
        ],
        "textures": [
          {
            "id": "swallow-original-maps",
            "label": "Adapted CC0 feather atlas",
            "author": "Weatherglass; inherited atlas from pistachio source",
            "license": "CC0 source declaration; original project additions",
            "artifactId": "sha256:417eb5218b2c502419e77705f41244a9d71b2e80112962fe433c79dbb382ce35",
            "sha256": "417eb5218b2c502419e77705f41244a9d71b2e80112962fe433c79dbb382ce35",
            "origin": "inherited",
            "notes": "No reference-photo pixels copied. Source feather atlas origin was not independently audited."
          },
          {
            "id": "swallow-body-maps",
            "label": "Original body, covert and tail coat",
            "author": "Weatherglass; inherited atlas from pistachio source",
            "license": "CC0 source declaration; original project additions",
            "artifactId": "sha256:417eb5218b2c502419e77705f41244a9d71b2e80112962fe433c79dbb382ce35",
            "sha256": "417eb5218b2c502419e77705f41244a9d71b2e80112962fe433c79dbb382ce35",
            "origin": "original",
            "notes": "Independently constructed color fields; no reference-photo pixels copied."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "bill_outer_tail_perched_distance": 0.18067052886400706,
          "bill_outer_tail_longitudinal": 0.174,
          "species_guide_wingspan": 0.34
        },
        "seededBounds": {},
        "method": "Pose-labelled metre measurements from the exact swallow02 export, with approximately 18 cm length / 34 cm span conservation guide. Seed variation is applied once.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study.",
          "Per-resident seeded size and animated extents must be measured from the actual posed skin."
        ]
      },
      "rig": {
        "id": "swallow-selected-rig-v2",
        "type": "skinned",
        "roles": [
          "body-head-neck",
          "four-wing-joints-per-side",
          "independent-forked-tail",
          "three-leg-segments-per-side",
          "toe-chains"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Daytime rest, takeoff, flap, interrupted upstroke, glide and landing",
            "description": "Absolute-time 7–8 Hz active cycles with articulated elbow/wrist, separate open-wing glide, early departure deployment and near-contact arrival closure. Timing is an engineering interpretation of adult studies; exact biological landing timing is unverified.",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Compact flight feet and supported rest",
            "description": "Three fixed-length leg segments and toe curl retract the feet in flight, then restore the authored neutral near a real support. Toe distance is reviewed; full claw wrapping is not certified.",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Weather/activity and shelter posture",
            "description": "Existing dusk/season visibility and a bounded held-rest shelter/head response are retained. Daytime rest is implemented; in-flight wind compensation, sheltered overnight roost and social behavior are not.",
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "swallow-gaits-1",
            "state": "implemented",
            "label": "Daytime rest, takeoff, flap, interrupted upstroke, glide and landing",
            "description": "Absolute-time 7–8 Hz active cycles with articulated elbow/wrist, separate open-wing glide, early departure deployment and near-contact arrival closure. Timing is an engineering interpretation of adult studies; exact biological landing timing is unverified.",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "swallow-daytime-scene-handoff"
            ]
          },
          {
            "id": "swallow-gaits-2",
            "state": "implemented",
            "label": "Compact flight feet and supported rest",
            "description": "Three fixed-length leg segments and toe curl retract the feet in flight, then restore the authored neutral near a real support. Toe distance is reviewed; full claw wrapping is not certified.",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "swallow-daytime-scene-handoff"
            ]
          }
        ],
        "environment": [
          {
            "id": "swallow-environment-1",
            "state": "implemented",
            "label": "Weather/activity and shelter posture",
            "description": "Existing dusk/season visibility and a bounded held-rest shelter/head response are retained. Daytime rest is implemented; in-flight wind compensation, sheltered overnight roost and social behavior are not.",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-original-bird-study",
              "runtime-biodiversity"
            ],
            "evidenceIds": [
              "swallow-daytime-scene-handoff"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "swallow-neighbor-gap",
            "state": "unverified",
            "label": "Species-specific neighbor interactions are not implemented",
            "description": "No courtship, flocking, predation or mutual collision response is claimed for this family.",
            "actionIds": [],
            "sourceIds": [],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "swallow-selected",
          "family": "swallow",
          "label": "Barn swallow",
          "assets": {
            "blender": {
              "artifactId": "sha256:7315089f620d0a9201d3f2f1b53a67eae58391e50957ac5509848778e7c4292f",
              "sha256": "7315089f620d0a9201d3f2f1b53a67eae58391e50957ac5509848778e7c4292f",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable source and exact rebuild recipe are retained in the separate source handoff."
            },
            "export": {
              "contractId": "swallow-selected-export-v2",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:417eb5218b2c502419e77705f41244a9d71b2e80112962fe433c79dbb382ce35",
                "sha256": "417eb5218b2c502419e77705f41244a9d71b2e80112962fe433c79dbb382ce35",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Editable source and exact rebuild recipe are retained in the separate source handoff."
              },
              "notes": "Fitted 65-joint adult swallow rig, explicit local-rest wing/tuck guides, separate wing/tail Folded targets and actual exported toe samples. Full/proxy rebuild byte-identically; study02 repairs proximal wing attachment."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "swallow-selected-full-8e91f7f2",
                "path": "assets/wildlife/swallow-adult02-8e91f7f2.glb",
                "sha256": "8e91f7f2c7af33df403cf470ef4913181d8cda3c4dca1371b19c0cecfbdb5086",
                "bytes": 2441920,
                "purpose": "Primary WebGL close detail.",
                "rigId": "swallow-selected-rig-v2",
                "exportContractId": "swallow-selected-export-v2",
                "triangles": 16332
              },
              {
                "id": "proxy",
                "payloadId": "swallow-selected-proxy-0bf86659",
                "path": "assets/wildlife/swallow-adult02-proxy-0bf86659.glb",
                "sha256": "0bf86659ca652a4bb3ba2bc242175b18d1f96fa9fdca819a50cd2f2a6126e9df",
                "bytes": 522016,
                "purpose": "Canvas and lower-detail same-rig derivative; Canvas keeps this mesh at every zoom.",
                "rigId": "swallow-selected-rig-v2",
                "exportContractId": "swallow-selected-export-v2",
                "triangles": 3099
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff"
          ],
          "reason": "CC0 cage derivatives, original additions and reference-only photos/research are recorded. Upstream inherited atlas pixels remain unaudited."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff"
          ],
          "reason": "Reference-guided adult body, forked tail and pointed articulated wings pass bounded source and scene views; the earlier inner-root gap is repaired. Graphic face and thin lower-leg treatment remain simplified."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff"
          ],
          "reason": "Daytime rest, takeoff, active flap/interrupted upstroke, glide, arrival and refold pass ordered native and Canvas pilot views. Active cadence is study-informed engineering; exact biological landing timing remains unverified."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff"
          ],
          "reason": "Bounded weather/activity/head response and deterministic occupied-support selection are implemented. No courtship, flocking, prey capture or overnight roost is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff"
          ],
          "reason": "All eight swallows and wrens are retained across four reviewed seeds on real shrub or grounded branches. Full/proxy support and tested trunk/berry/stem checks pass; nearest-foot gaps remain proximity-scoped, not wrapped claw grip."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff",
            "swallow-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "swallow-daytime-scene-handoff"
          ],
          "reason": "Actual rest, 222 departure/return frames and desktop/narrow Canvas views show readable attached surfaces on real supports. Wood, facial detail, groundcover and Canvas glass-depth handling retain stated limits."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "swallow-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 2
        },
        "budgets": {
          "standardTriangles": 16332,
          "fallbackTriangles": 3099
        }
      }
    },
    {
      "id": "rabbit-family",
      "family": "rabbit",
      "identity": {
        "label": "Photo-informed generic rabbit",
        "taxon": {
          "name": null,
          "rank": "unresolved",
          "confidence": "unverified",
          "basis": "Generic source anatomy informed by species photographs; exact species equivalence is not established."
        },
        "notes": "Current generic anatomy and movement passed the scoped scene review. Exact species comparisons and the remaining presentation limits stay open."
      },
      "habitat": [
        "woodland-meadow"
      ],
      "provenance": {
        "models": [
          {
            "id": "rabbit-cc0-base",
            "label": "Original Rabbit base",
            "author": "Čestmír Dammer (CDmir), with TinyWorlds",
            "license": "CC0 1.0",
            "url": "https://opengameart.org/content/rabbit-0",
            "notes": "Adapted in Blender; the upstream label is generic. Exact species identity is not implied."
          }
        ],
        "references": [
          {
            "id": "rabbit-photo-1",
            "label": "Cottontail form reference",
            "author": "NPS",
            "license": "Public domain",
            "url": "https://commons.wikimedia.org/wiki/File:Eastern_Cottontail_(Sylvilagus_floridanus)_(2564f316-e9da-48c2-9928-fb79c7637426).jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          },
          {
            "id": "rabbit-photo-2",
            "label": "Cottontail feeding reference",
            "author": "Mara Koenig / USFWS",
            "license": "Public domain",
            "url": "https://commons.wikimedia.org/wiki/File:Cottontail_Lunch_(27710445765).jpg",
            "notes": "Form and color reference; linked photograph is not bundled in the app."
          }
        ],
        "textures": [
          {
            "id": "rabbit-source-maps",
            "label": "Inherited source maps with adaptation",
            "author": "CC0 source model authors and Weatherglass adaptation",
            "license": "CC0 source asset declaration",
            "url": "https://opengameart.org/content/rabbit-0",
            "origin": "inherited",
            "notes": "Reference-photo pixels were not projected. Upstream source-map origin has not been independently audited."
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "neutral_nose_to_tail": 0.44,
          "seated_ear_height": 0.379
        },
        "seededBounds": {},
        "method": "Source-model pose measurements, uniform nominal multiplier 0.30 and 0.1755 world units/m. These are model dimensions, not biological measurements.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study."
        ]
      },
      "rig": {
        "id": "rabbit-selected-rig-v1",
        "type": "skinned",
        "roles": [
          "hips",
          "spine",
          "chest",
          "neck",
          "head",
          "ears",
          "fore-two-segment-chains",
          "hind-three-segment-chains",
          "paws"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Hop: push, flight, fore catch, recovery, hind catch, settle",
            "description": "Hop: push, flight, fore catch, recovery, hind catch, settle",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Seated rest",
            "description": "Seated rest",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "gaits-3",
            "kind": "procedural",
            "label": "Vegetation browsing",
            "description": "Vegetation browsing",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "gaits-4",
            "kind": "procedural",
            "label": "Alert look",
            "description": "Alert look",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Wind and exposure change ears and attention",
            "description": "Wind and exposure change ears and attention",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Season modulates browsing",
            "description": "Season modulates browsing",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "neighbors-1",
            "kind": "procedural",
            "label": "Neighbor proximity changes head and ear attention; route remains reserved",
            "description": "Neighbor proximity changes head and ear attention; route remains reserved",
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ]
          },
          {
            "id": "source-clip-sitting",
            "kind": "clip",
            "label": "Sitting (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "rabbit-cc0-base"
            ]
          },
          {
            "id": "source-clip-alert",
            "kind": "clip",
            "label": "Alert (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "rabbit-cc0-base"
            ]
          },
          {
            "id": "source-clip-running",
            "kind": "clip",
            "label": "Running (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "rabbit-cc0-base"
            ]
          },
          {
            "id": "source-clip-jump",
            "kind": "clip",
            "label": "Jump (source reference clip)",
            "description": "Bundled original-rig motion reference. The app samples or adapts this through its terrain-aware behavior; raw source motion is not a contact-safe runtime promise.",
            "sourceIds": [
              "rabbit-cc0-base"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "rabbit-gaits-1",
            "state": "implemented",
            "label": "Hop: push, flight, fore catch, recovery, hind catch, settle",
            "description": "Hop: push, flight, fore catch, recovery, hind catch, settle",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          },
          {
            "id": "rabbit-gaits-2",
            "state": "implemented",
            "label": "Seated rest",
            "description": "Seated rest",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          },
          {
            "id": "rabbit-gaits-3",
            "state": "implemented",
            "label": "Vegetation browsing",
            "description": "Vegetation browsing",
            "actionIds": [
              "gaits-3"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          },
          {
            "id": "rabbit-gaits-4",
            "state": "implemented",
            "label": "Alert look",
            "description": "Alert look",
            "actionIds": [
              "gaits-4"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          }
        ],
        "environment": [
          {
            "id": "rabbit-environment-1",
            "state": "implemented",
            "label": "Wind and exposure change ears and attention",
            "description": "Wind and exposure change ears and attention",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          },
          {
            "id": "rabbit-environment-2",
            "state": "implemented",
            "label": "Season modulates browsing",
            "description": "Season modulates browsing",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          }
        ],
        "neighbors": [
          {
            "id": "rabbit-neighbors-1",
            "state": "implemented",
            "label": "Neighbor proximity changes head and ear attention; route remains reserved",
            "description": "Neighbor proximity changes head and ear attention; route remains reserved",
            "actionIds": [
              "neighbors-1"
            ],
            "sourceIds": [
              "runtime-original-rabbit-motion"
            ],
            "evidenceIds": [
              "rabbit-published-technical"
            ]
          }
        ]
      },
      "variants": [
        {
          "id": "rabbit-selected",
          "family": "rabbit",
          "label": "Generic rabbit",
          "assets": {
            "blender": {
              "artifactId": "sha256:1710ecdbdde1c024180042f281c8d54c563a2b498dbda8466dfdcd4ce5fda7f9",
              "sha256": "1710ecdbdde1c024180042f281c8d54c563a2b498dbda8466dfdcd4ce5fda7f9",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Editable authoring artifact in the separately packaged source; a browser download is not bundled."
            },
            "export": {
              "contractId": "rabbit-selected-export-v1",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:5f4ce5de2c472eb313f133f069371e4a77eddb1cb823081af1d3a339d656c5b2",
                "sha256": "5f4ce5de2c472eb313f133f069371e4a77eddb1cb823081af1d3a339d656c5b2",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Final ear-refinement stage. Complete clean-rebuild inputs and ordering are recorded in the separately delivered source package."
              },
              "notes": "This registry contract wraps the frozen export; native source rig contracts are retained in the source package."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "rabbit-selected-full-9fd0696b",
                "path": "assets/wildlife/rabbit-original-9fd0696b.glb",
                "sha256": "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2",
                "bytes": 5693572,
                "purpose": "Selected normal WebGL export; close-only fur is gated at runtime.",
                "rigId": "rabbit-selected-rig-v1",
                "exportContractId": "rabbit-selected-export-v1",
                "triangles": 45776
              },
              {
                "id": "proxy",
                "payloadId": "rabbit-selected-proxy-f46341d7",
                "path": "assets/wildlife/rabbit-original-proxy-f46341d7.glb",
                "sha256": "f46341d730024ddb2a582438be85c30b4bfc391cb4b48d466302c39d781074a6",
                "bytes": 507920,
                "purpose": "Canvas fallback; visible macro simplification.",
                "rigId": "rabbit-selected-rig-v1",
                "exportContractId": "rabbit-selected-export-v1",
                "triangles": 2192
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Selected CC0 source-rig exports retain inherited photographic/baked maps whose upstream pixel origins were not independently audited. Additional anatomy-reference photographs informed shape and pose; those new reference pixels were not projected onto the model."
        },
        "anatomy": {
          "state": "validated",
          "evidenceIds": [
            "rabbit-generic-anatomy-534"
          ],
          "reason": "Connected generic anatomy and surface continuity passed the actual-scene gate. Species-level accuracy remains open.",
          "validation": {
            "sourceHashes": {
              "blender": "1710ecdbdde1c024180042f281c8d54c563a2b498dbda8466dfdcd4ce5fda7f9",
              "export-recipe": "5f4ce5de2c472eb313f133f069371e4a77eddb1cb823081af1d3a339d656c5b2"
            },
            "assetHashes": [
              "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2"
            ],
            "renderer": "webgl",
            "lods": [
              "full"
            ],
            "variantIds": [
              "rabbit-selected"
            ],
            "fixtureIds": [
              "rabbit-calibrated-rest",
              "rabbit-calibrated-movement"
            ],
            "date": "2026-10-11",
            "scope": "Bounded photo-informed generic anatomy and connected surface gate under actual landscape light; exact species anatomy remains unverified.",
            "limitations": [
              "Generic source identity; exact cottontail or white-tailed deer equivalence is not established.",
              "Faces, coats and muscle contours are simplified.",
              "Proxy macro anatomy is outside this full-detail visual claim."
            ]
          }
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [
            "rabbit-published-technical"
          ],
          "reason": "The listed procedural patterns exist. Biological timing and full common-gait coverage remain a separate review."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "rabbit-published-technical"
          ],
          "reason": "Only the listed causal responses are implemented; no broader animal intelligence is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [
            "rabbit-published-technical"
          ],
          "reason": "Published terrain, water and host-contact checks are retained as hash-scoped evidence; new anatomy requires fresh checks."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "rabbit-published-technical",
            "rabbit-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [
            "rabbit-published-technical"
          ],
          "reason": "Current landscape focus is available. Macro groundcover scale, contact light and proxy detail remain presentation limits."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "rabbit-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 3
        },
        "budgets": {
          "standardTriangles": 45776,
          "fallbackTriangles": 2192
        }
      }
    },
    {
      "id": "fish-family",
      "family": "fish",
      "identity": {
        "label": "Photo-informed common carp",
        "taxon": {
          "name": "Cyprinus carpio",
          "rank": "species-reference-target",
          "confidence": "medium",
          "basis": "Matched USFWS side-photo comparison, four barbels and connected operculum; inset eyes, fixed mouth and procedural fins remain simplified."
        },
        "notes": "Actual-water swim and lower-detail comparison passed; selected-loader lifecycle and fallback rendering remain separate gates."
      },
      "habitat": [
        "freshwater"
      ],
      "provenance": {
        "models": [
          {
            "id": "fish-original-source",
            "label": "Original Blender-authored model",
            "author": "Weatherglass authoring project",
            "license": "Original project asset; redistribution terms not separately assigned",
            "artifactId": "sha256:7b7734c69e6cd84c1ab2dd3ab55294a4160e37da3c8d2ba426d4337005cfad44",
            "sha256": "7b7734c69e6cd84c1ab2dd3ab55294a4160e37da3c8d2ba426d4337005cfad44",
            "notes": "Photo-informed common carp source; same11-joint rig. Coat derives from the credited public-domain Sam Stukel/USFWS photo; mirrored projection retains some source lighting. Fins and inset eyes are simplified."
          }
        ],
        "references": [
          {
            "id": "fish-photo-1",
            "label": "Common carp side reference",
            "author": "Sam Stukel / USFWS",
            "license": "Public domain",
            "url": "https://commons.wikimedia.org/wiki/File:Common_Carp_(Cyprinus_carpio)_(51022534501).jpg",
            "notes": "This verified public-domain Sam Stukel/USFWS photograph supplies the projected side-coat pixels as well as the profile reference."
          }
        ],
        "textures": [
          {
            "id": "fish-original-maps",
            "label": "USFWS photo-derived carp coat and procedural fins",
            "author": "Sam Stukel / USFWS; Weatherglass projection and cleanup",
            "license": "Public domain US government photo; original project texture adaptation",
            "artifactId": "sha256:4d4d29675c6aecbacf21c9580015b0172b7e44ed0114e35f0c43660af6bff738",
            "sha256": "4d4d29675c6aecbacf21c9580015b0172b7e44ed0114e35f0c43660af6bff738",
            "origin": "photo-derived",
            "notes": "Photo-derived side projection, mirrored opposite side with background removed, local eye/pectoral cleanup and partial illumination flattening. Residual lighting and bilateral repetition remain. Fins are procedural.",
            "url": "https://commons.wikimedia.org/wiki/File:Common_Carp_(Cyprinus_carpio)_(51022534501).jpg"
          }
        ],
        "runtime": [
          {
            "id": "runtime-animal-detail",
            "label": "animal detail",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-detail.js",
            "sha256": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-environment",
            "label": "animal environment",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-environment.js",
            "sha256": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry",
            "label": "animal registry",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry.js",
            "sha256": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-contract",
            "label": "animal registry contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-contract.js",
            "sha256": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three",
            "label": "animal registry three",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three.js",
            "sha256": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-registry-three-bindings",
            "label": "animal registry three bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-registry-three-bindings.js",
            "sha256": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animal-surface",
            "label": "animal surface",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animal-surface.js",
            "sha256": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals",
            "label": "animals",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals.js",
            "sha256": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-animals3d",
            "label": "animals3d",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/animals3d.js",
            "sha256": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-attention",
            "label": "authored attention",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-attention.js",
            "sha256": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-coat",
            "label": "authored coat",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-coat.js",
            "sha256": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-pose-sampler",
            "label": "authored pose sampler",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-pose-sampler.js",
            "sha256": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-authored-wildlife",
            "label": "authored wildlife",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/authored-wildlife.js",
            "sha256": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-biodiversity",
            "label": "biodiversity",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/biodiversity.js",
            "sha256": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-deadwood-support",
            "label": "bird deadwood support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-deadwood-support.js",
            "sha256": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-bird-host-clearance",
            "label": "bird host clearance",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/bird-host-clearance.js",
            "sha256": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-bindings",
            "label": "butterfly four wing bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-bindings.js",
            "sha256": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-butterfly-four-wing-pose",
            "label": "butterfly four wing pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/butterfly-four-wing-pose.js",
            "sha256": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-asset",
            "label": "deer asset",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-asset.js",
            "sha256": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-profile",
            "label": "deer profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-profile.js",
            "sha256": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-deer-skin",
            "label": "deer skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/deer-skin.js",
            "sha256": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-embedded-image",
            "label": "embedded image",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/embedded-image.js",
            "sha256": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-anatomy-profile",
            "label": "firefly anatomy profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-anatomy-profile.js",
            "sha256": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-firefly-display",
            "label": "firefly display",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/firefly-display.js",
            "sha256": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-fish-motion",
            "label": "fish motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/fish-motion.js",
            "sha256": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-authored-support",
            "label": "frog authored support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-authored-support.js",
            "sha256": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-bank-plan",
            "label": "frog bank plan",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-bank-plan.js",
            "sha256": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contact-ik",
            "label": "frog contact ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contact-ik.js",
            "sha256": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-contract",
            "label": "frog contract",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-contract.js",
            "sha256": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-frog-pose",
            "label": "frog pose",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/frog-pose.js",
            "sha256": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-geology",
            "label": "geology",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/geology.js",
            "sha256": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-landscape",
            "label": "landscape",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/landscape.js",
            "sha256": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-limb-ik",
            "label": "limb ik",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/limb-ik.js",
            "sha256": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-locomotion",
            "label": "locomotion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/locomotion.js",
            "sha256": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-profile",
            "label": "original bird profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-profile.js",
            "sha256": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-bird-study",
            "label": "original bird study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-bird-study.js",
            "sha256": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-motion",
            "label": "original doe motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-motion.js",
            "sha256": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-profile",
            "label": "original doe profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-profile.js",
            "sha256": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-doe-study",
            "label": "original doe study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-doe-study.js",
            "sha256": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-profile",
            "label": "original frog profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-profile.js",
            "sha256": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-frog-study",
            "label": "original frog study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-frog-study.js",
            "sha256": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-behavior",
            "label": "original rabbit behavior",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-behavior.js",
            "sha256": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-motion",
            "label": "original rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-motion.js",
            "sha256": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-profile",
            "label": "original rabbit profile",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-profile.js",
            "sha256": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-original-rabbit-study",
            "label": "original rabbit study",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/original-rabbit-study.js",
            "sha256": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-package-lock",
            "label": "package lock",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "package-lock.json",
            "sha256": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-plant-supports",
            "label": "plant supports",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/plant-supports.js",
            "sha256": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-rabbit-motion",
            "label": "rabbit motion",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/rabbit-motion.js",
            "sha256": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-robin-core10-bindings",
            "label": "robin core10 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/robin-core10-bindings.js",
            "sha256": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-simulation",
            "label": "simulation",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/simulation.js",
            "sha256": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support",
            "label": "skinned support",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support.js",
            "sha256": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-skinned-support-bounds",
            "label": "skinned support bounds",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/skinned-support-bounds.js",
            "sha256": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-swallow-adult01-bindings",
            "label": "swallow adult01 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/swallow-adult01-bindings.js",
            "sha256": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain",
            "label": "terrain",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain.js",
            "sha256": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-terrain-resolution",
            "label": "terrain resolution",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/terrain-resolution.js",
            "sha256": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-weather-lighting",
            "label": "weather lighting",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/weather-lighting.js",
            "sha256": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-assets",
            "label": "wildlife assets",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-assets.js",
            "sha256": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-loading",
            "label": "wildlife loading",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-loading.js",
            "sha256": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-manifest",
            "label": "wildlife manifest",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-manifest.js",
            "sha256": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-rigid",
            "label": "wildlife rigid",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-rigid.js",
            "sha256": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wildlife-skin",
            "label": "wildlife skin",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wildlife-skin.js",
            "sha256": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-world-scale",
            "label": "world scale",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/world-scale.js",
            "sha256": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          },
          {
            "id": "runtime-wren-core04-bindings",
            "label": "wren core04 bindings",
            "author": "Weatherglass runtime authoring project",
            "license": "Original project implementation; engineering design parameters",
            "path": "src/wren-core04-bindings.js",
            "sha256": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d",
            "notes": "Implementation source; source-model authors do not supply these procedural behaviors."
          }
        ]
      },
      "measurements": {
        "unit": "m",
        "nominal": {
          "neutral_width": 0.178205,
          "neutral_height": 0.203703,
          "neutral_depth": 0.54631
        },
        "seededBounds": {},
        "method": "Approximate neutral model envelope at nominal local scale, including appendages and spread wings; 0.1755 world units/m. These are engineering bounds, not biological body measurements.",
        "limitations": [
          "Pose and seeded phenotype alter visible extents.",
          "Exact biological dimensions are not established for this study.",
          "Per-resident seeded size and animated extents must be measured from the actual posed skin."
        ]
      },
      "rig": {
        "id": "fish-selected-rig-v1",
        "type": "skinned",
        "roles": [
          "body",
          "head",
          "tail",
          "caudal",
          "paired-fins",
          "dorsal",
          "anal"
        ],
        "actions": [
          {
            "id": "gaits-1",
            "kind": "procedural",
            "label": "Swim and turn",
            "description": "Swim and turn",
            "sourceIds": [
              "runtime-animals"
            ]
          },
          {
            "id": "gaits-2",
            "kind": "procedural",
            "label": "Tail and fin articulation",
            "description": "Tail and fin articulation",
            "sourceIds": [
              "runtime-animals"
            ]
          },
          {
            "id": "environment-1",
            "kind": "procedural",
            "label": "Water and habitat bounds constrain the swim volume",
            "description": "Water and habitat bounds constrain the swim volume",
            "sourceIds": [
              "runtime-animals"
            ]
          },
          {
            "id": "environment-2",
            "kind": "procedural",
            "label": "Exposure changes effort",
            "description": "Exposure changes effort",
            "sourceIds": [
              "runtime-animals"
            ]
          },
          {
            "id": "neighbors-1",
            "kind": "procedural",
            "label": "Nearby residents influence head and fin steering; no emergent schooling is claimed",
            "description": "Nearby residents influence head and fin steering; no emergent schooling is claimed",
            "sourceIds": [
              "runtime-animals"
            ]
          }
        ]
      },
      "behaviors": {
        "gaits": [
          {
            "id": "fish-gaits-1",
            "state": "implemented",
            "label": "Swim and turn",
            "description": "Swim and turn",
            "actionIds": [
              "gaits-1"
            ],
            "sourceIds": [
              "runtime-animals"
            ],
            "evidenceIds": []
          },
          {
            "id": "fish-gaits-2",
            "state": "implemented",
            "label": "Tail and fin articulation",
            "description": "Tail and fin articulation",
            "actionIds": [
              "gaits-2"
            ],
            "sourceIds": [
              "runtime-animals"
            ],
            "evidenceIds": []
          }
        ],
        "environment": [
          {
            "id": "fish-environment-1",
            "state": "implemented",
            "label": "Water and habitat bounds constrain the swim volume",
            "description": "Water and habitat bounds constrain the swim volume",
            "actionIds": [
              "environment-1"
            ],
            "sourceIds": [
              "runtime-animals"
            ],
            "evidenceIds": []
          },
          {
            "id": "fish-environment-2",
            "state": "implemented",
            "label": "Exposure changes effort",
            "description": "Exposure changes effort",
            "actionIds": [
              "environment-2"
            ],
            "sourceIds": [
              "runtime-animals"
            ],
            "evidenceIds": []
          }
        ],
        "neighbors": [
          {
            "id": "fish-neighbors-1",
            "state": "implemented",
            "label": "Nearby residents influence head and fin steering; no emergent schooling is claimed",
            "description": "Nearby residents influence head and fin steering; no emergent schooling is claimed",
            "actionIds": [
              "neighbors-1"
            ],
            "sourceIds": [
              "runtime-animals"
            ],
            "evidenceIds": []
          }
        ]
      },
      "variants": [
        {
          "id": "fish-selected",
          "family": "fish",
          "label": "Common carp",
          "assets": {
            "blender": {
              "artifactId": "sha256:7b7734c69e6cd84c1ab2dd3ab55294a4160e37da3c8d2ba426d4337005cfad44",
              "sha256": "7b7734c69e6cd84c1ab2dd3ab55294a4160e37da3c8d2ba426d4337005cfad44",
              "availability": "external",
              "delivery": "external-source-package",
              "notes": "Photo-informed common carp source; same11-joint rig. Coat derives from the credited public-domain Sam Stukel/USFWS photo; mirrored projection retains some source lighting. Fins and inset eyes are simplified."
            },
            "export": {
              "contractId": "fish-selected-export-v1",
              "contractVersion": "1.0.0",
              "tool": "Blender glTF export",
              "version": "4.3.2",
              "recipe": {
                "artifactId": "sha256:07148a7b048b0a9f4a5e77e8f86fcbc3fed3baf4772562aef3f1a77be5c3a43c",
                "sha256": "07148a7b048b0a9f4a5e77e8f86fcbc3fed3baf4772562aef3f1a77be5c3a43c",
                "availability": "external",
                "delivery": "external-source-package",
                "notes": "Exact source recipe in the separately packaged editable source."
              },
              "notes": "Photo-informed common carp source; same11-joint rig. Coat derives from the credited public-domain Sam Stukel/USFWS photo; mirrored projection retains some source lighting. Fins and inset eyes are simplified."
            },
            "lods": [
              {
                "id": "full",
                "payloadId": "fish-selected-full-4aafc94c",
                "path": "assets/wildlife/carp-photo5-4aafc94c.glb",
                "sha256": "4aafc94cc8eb0fcf4408eed0646c93f15c7d3ae401b80d261848d502dfc65ee5",
                "bytes": 693128,
                "purpose": "Selected WebGL export.",
                "rigId": "fish-selected-rig-v1",
                "exportContractId": "fish-selected-export-v1",
                "triangles": 4722
              },
              {
                "id": "proxy",
                "payloadId": "fish-selected-proxy-67843d62",
                "path": "assets/wildlife/carp-photo5-proxy-67843d62.glb",
                "sha256": "67843d62ef4ce3e3b44001c4972a5ff37d3d62850d627317de38574ae429271a",
                "bytes": 231208,
                "purpose": "Canvas fallback; visible macro simplification.",
                "rigId": "fish-selected-rig-v1",
                "exportContractId": "fish-selected-export-v1",
                "triangles": 1587
              }
            ]
          },
          "selectedLods": {
            "standard": "full",
            "fallback": "proxy"
          }
        }
      ],
      "status": {
        "provenance": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Photo-derived mirrored base colour uses the credited public-domain Sam Stukel/USFWS photograph. No calibrated reflectance claim."
        },
        "anatomy": {
          "state": "implemented",
          "evidenceIds": [
            "carp-photo5-source-runtime"
          ],
          "reason": "Matched actual-water profile and swimming retain connected body/operculum, four barbels and the credited photo-derived coat. Full/proxy geometry and source rig checks passed their bounded review."
        },
        "movement": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "The listed procedural patterns exist. Biological timing and full common-gait coverage remain a separate review."
        },
        "interactions": {
          "state": "implemented",
          "evidenceIds": [
            "fish-published-technical"
          ],
          "reason": "Only the listed causal responses are implemented; no broader animal intelligence is claimed."
        },
        "contacts": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Published terrain, water and host-contact checks are retained as hash-scoped evidence; new anatomy requires fresh checks."
        },
        "lifecycle": {
          "state": "implemented",
          "evidenceIds": [
            "fish-normal-selection-v26"
          ],
          "reason": "Normal selected full/proxy loading, paused focus, malformed retention, replacement, reset and disposal pass the bounded primary and Canvas gates. Combined primary checks retain 19 independent skeletons across all twelve slots."
        },
        "presentation": {
          "state": "implemented",
          "evidenceIds": [],
          "reason": "Current landscape focus is available. Macro groundcover scale, contact light and proxy detail remain presentation limits."
        }
      },
      "runtime": {
        "contracts": [
          {
            "id": "fish-runtime-534",
            "version": "1.0.0",
            "sourceHashes": {
              "animal-detail": "b87bb294b2eb88c7662d4ddd2aa290d6915d775f5764344258503b72f92423a5",
              "animal-environment": "7e581899f77fa86af1abe5189b6cd144af5b9a46317aaa545ffd5eeb466d1ba4",
              "animal-registry": "1e7539d0a0c3ffb1f0d88c2f9aeab0c3a4ad11880668067187dfc5864ff74d9f",
              "animal-registry-contract": "e35949e5c6cf50c542292c496151e2023f8a33a1be7b6c4633f482c516bd7536",
              "animal-registry-three": "8301e21491f46d11c07a573f0c71fbed08852f2df1e49dd5ea4e0c9029e5c3c4",
              "animal-registry-three-bindings": "25e1d37b844396fed0fff1ed98dc4cd6c60ff5dcad05dad59ef8a4f2f0038d23",
              "animal-surface": "99e6e93f7e55d677b4a9314a7c53d67bd71bac3284a1cf11428925c245c01233",
              "animals": "86ad1c1af93cab73b3889e29fb0de1dccc7f6d5495c64cc12bdb9285e77552aa",
              "animals3d": "fdff4227e5a20ad14ed756653d80d1484ce16ca41bd07447fc3adffd022b4a7a",
              "authored-attention": "c7894a6a8713d484e339d65f31ebc1684d5fd1e4d3e1e40a938529f78ac63b21",
              "authored-coat": "6f5961d2e1e57565ac0d162a898fd90b3e2185714a4735de59770192fd8ea0cc",
              "authored-pose-sampler": "98a97a64e26f1e4b047f9380e6d424c1f97fa1f65d151f55bc5ce166be3174c7",
              "authored-wildlife": "c6da0788f23ac48bcf963d858414989015c987e13ac447e55353d9f106b3c8bb",
              "biodiversity": "7a1ef0e787e145155fcd02aa16d62f51abfe7b514cbc20570c5ec5ef43ff4c6b",
              "bird-deadwood-support": "8ebaccfa3284f9d57216176ba633582cb4a9b52e3487ecc57ea9f68db7d29515",
              "bird-host-clearance": "f3fa8191a11412c3b34bd84d1b0640e89a67b03c18675837454ac4051db3d64d",
              "butterfly-four-wing-bindings": "49c41108d0c53cc7d94f046d1f7449872df27bf64a76c9ffc29da1c9909034f7",
              "butterfly-four-wing-pose": "a6d2178213341539e89b11b8b1ae0c9e2852de394d6dd910a1e8a651cd5b8df4",
              "deer-asset": "84aabbfadd883d0e3f73215e56e984312d01ae6f8bf634afcd27e1eed2b189c8",
              "deer-profile": "f5e6ea51cfb4f487567e32879fcd570b6006488dc991b1671c91e9358f2df217",
              "deer-skin": "1ec19742050fec0d984b9f62a09341faa01f5675ac02cf88cdce48712d1c3e45",
              "embedded-image": "48746ae632247361240f294cc96de8636825c549ce35f4a567073c8299759878",
              "firefly-anatomy-profile": "0bdb3b2067e818592cc55312ff98a34ca02c4d8b9404890ec0c9facb14505563",
              "firefly-display": "100697fe035de97cd4e6fe390e20e60c68d599622c28787b2673a2b4eb5e718c",
              "fish-motion": "754edc2c805bdcb3bae4be13d2b51958059cce4d551e44971f57980819e0450f",
              "frog-authored-support": "7f82638f657acf4a98d73e1e668ecdf06467feb2d0ff78e0cbd950ebc1e61669",
              "frog-bank-plan": "0de6e6114b9cc1d9d2adbadd9d4e5ebd0706310c77a440c8aa7004497fcd54a6",
              "frog-contact-ik": "b8cd8b96f03d5c26b0cbf2ea4fb98b987f6362ada29748ff4f33d469ce463e4e",
              "frog-contract": "4c4140fa40c85add74af7baeba4b48583bc9bb678ddc6240672797fa3e0bac75",
              "frog-pose": "2339fce270bf15fde7a1a73da8d2556d048fd1b7d36ee88061597ab2d6434e6d",
              "geology": "201051fc1108efe93cf63d1a5582dda5c4862274665aa37bdd9bbb1f7d62f9b6",
              "landscape": "e3c786c8de033ad1cf1d47d08d438ee3bbf7e94c9d451c0670b5a1f6b264d0b7",
              "limb-ik": "5daa12b978f47d9c03f3fe8b0f18bb0c31d237d5e9c2eff5d65a5dab30e56373",
              "locomotion": "5f67284ce4ade2fc80494896e69392bd200c79117f404da7b50743556032e683",
              "original-bird-profile": "e7fbadfcaa808fe098a5ed5d7b99aec39b5bcfb4858bd7240bb59f36ee1ed0e8",
              "original-bird-study": "ca8ac15693f3c6538c9689ca2d638b1d089cfd32f254b9fd54cc7b5f620f5c54",
              "original-doe-motion": "c62c716e35d5c0f343857f97e2f149b4d60f9d538cb8c953ebc809fd69cb7438",
              "original-doe-profile": "eb68e5f51eb2b5870376ec29a9123f6afe3b133d1e1c47bd55dd5d7d60c114a7",
              "original-doe-study": "0ce4379ce8f20aaef481a7059eebc9b76a28c019ff8cca807a6d6f20a71b06d0",
              "original-frog-profile": "e12148adf498b806e026ac8173fb6e851b0cde2b59df3d75efecf9549f7c797f",
              "original-frog-study": "5d4f6899b1168dfa576c28d494fc133d8066e4a25a2ac477978016c3f9068788",
              "original-rabbit-behavior": "be5cb6d7a45a5e1921d81a8564dcc4180a68ee94dcab217fac6c6a6195d05ab8",
              "original-rabbit-motion": "0130b4cc15619b1073426ac28934757dd77424e96cc66c2ffd06f092093e9acc",
              "original-rabbit-profile": "67fe606425e57dd3dba13ff08e420ebc9a6a61adde82ebe7fd4d705076d17577",
              "original-rabbit-study": "68152e0f63ade31120a761f44ed0dc18a7290c21c76f6e9b2a2e51f73532d6b0",
              "package-lock": "16ab9f009331559afd7f499401de4531967ecb468b51efc46cd191e90c0adb4f",
              "plant-supports": "c3c050f933e2ff874c6edfb5a7d37358dd71247c983fd28895d250aa0b13b993",
              "rabbit-motion": "99a9300271ac00e98bce2df75f74cad3338a97d859fc660f0101d08c9510e8d5",
              "robin-core10-bindings": "baf039526e5279dc748b07c5595e53e6707ae48f1e2aa0b87a7fd8965f76f7c1",
              "simulation": "9cf7a0570f4ffefa2afd9d89377b51e90ce09e78e6b890140921279f0d941bd1",
              "skinned-support": "cad7a48c3337cd5b56c60e68618b65dbd4b18b6b58fe92ed3b159afb629620ae",
              "skinned-support-bounds": "1539eca782b2f6202bff6e8824f27786434679ecdd650284b6ed4020e3f57be7",
              "swallow-adult01-bindings": "f73681bd6a539930fc8866bca894b56f389dccc46abcac311d29b2a328bb9e32",
              "terrain": "ff9dbbb29272a8d539bb9a2a0e5da0298b12a132f8802f8b5c6ffc0fef8920db",
              "terrain-resolution": "1bd6e6d83cbf3eeef4654fc76c3261556d815021e7843fce8d3a76e0cdf9a75f",
              "weather-lighting": "0794d9735c52f0098a626ea16106e09c0ec929d54d991cacfd2878686ce787a0",
              "wildlife-assets": "a5789353defb7e978be53e1b97e58d96ef2f7c9bb80456b0f8e5a5c6f9deb251",
              "wildlife-loading": "0651d84856c58c28fdd2dc11a9acca7ac90f2af7d1e4b9923c9161374ca9ac6f",
              "wildlife-manifest": "642daac668083aab71bbc688bf90c8e927d17a7b8111f8ed95ae6eb90855ac86",
              "wildlife-rigid": "c2c69445c5edab0f295a34529433acf5ae9c29a3367fb72c54b6185b7d69b4b3",
              "wildlife-skin": "7ead342f9a4078e741d46f0422fb906231db8ee88cb16342e3a2d0d8a4e9698c",
              "world-scale": "bfaba32a7731d7112d71d7ef84d5f0cf77634e0a04c28f8d9125f4a995598347",
              "wren-core04-bindings": "242b19698661bb8f58f839ad9c66ffb1ea52c98afd41e9556a7881e7d0021c4d"
            },
            "notes": "Transitive local source closure for deterministic placement, scale, terrain geometry/support, behavior, animation sampling and rig adaptation. The dependency lockfile is included in this digest scope."
          }
        ],
        "population": {
          "maximumResidents": 5
        },
        "budgets": {
          "standardTriangles": 4722,
          "fallbackTriangles": 1587
        }
      }
    }
  ],
  "evidence": [
    {
      "id": "deer-published-technical",
      "kind": "published-release-review",
      "family": "deer",
      "variantIds": [
        "deer-selected"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4",
        "5dc17284df270558928b161b459f8183611eee7701e1aaf3476e35400971899d"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "deer-generic-anatomy-534",
      "kind": "bounded-native-visual-review",
      "family": "deer",
      "dimensions": [
        "anatomy"
      ],
      "artifactId": "sha256:6c35e60794084cd6c9f5ff19fa6fb0b5a775f45c6bc94bc11562d6eaf5ac88c3",
      "sourceHashes": {
        "blender": "d5d94a7bcc471b4b0632deeb686240952eeb930287dc87b6c22e40bde2cca1f1"
      },
      "assetHashes": [
        "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4"
      ],
      "renderer": "webgl",
      "lods": [
        "full"
      ],
      "variantIds": [
        "deer-selected"
      ],
      "fixtureIds": [
        "deer-calibrated-rest",
        "deer-calibrated-movement"
      ],
      "date": "2026-10-11",
      "scope": "Bounded photo-informed generic anatomy and connected surface gate under actual landscape light; exact species anatomy remains unverified.",
      "limitations": [
        "Generic source identity; exact cottontail or white-tailed deer equivalence is not established.",
        "Faces, coats and muscle contours are simplified.",
        "Proxy macro anatomy is outside this full-detail visual claim."
      ]
    },
    {
      "id": "butterfly-published-technical",
      "kind": "published-release-review",
      "family": "butterfly",
      "variantIds": [
        "butterfly-monarch",
        "butterfly-common-blue",
        "butterfly-cabbage-white"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "89edfe272582616ada80c2438299844f4337fd143914f234e0ca5d9f74be0fb4",
        "35ddaa541fe59ed56a7f2d4f539712c0a017239343cfd1884a1e828cae11657d",
        "444568e22dd87ca97af0c31b438d6af2cef2ed496e1388e9400850746ebc4be4",
        "6bfec9cd38de6456b8087f6eb3a0c2e51bdbfdd5face30d545e51e8edaa337d8",
        "60fdc8d723c4325a09226660eccd4a11b41f57f0021a8ea83061d99a505541d9",
        "8a1fc1fff01a5cdf4802c58e93f61205c1b588c18b2548edeb8d3a475faf467d"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "dragonfly-published-technical",
      "kind": "published-release-review",
      "family": "dragonfly",
      "variantIds": [
        "dragonfly-selected"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "246405dd1a2ba293337a56866e3b9103e00b829102ec839f93a255c5d45682f9",
        "2abafd8fe03d9d43f9509a127192b491d24a791db8578b6e1a4135d422d0ebfa"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "firefly-published-technical",
      "kind": "published-release-review",
      "family": "firefly",
      "variantIds": [
        "firefly-selected"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "5cd2d6212f22170ced072ca310188bb3e135f65056f0ba127ed352bd7e7ca31a",
        "44ae5d6ef967b5892177968d9c9b8d8b5ef06b1ca21d89890f31558308bcd6fa"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "robin-published-technical",
      "kind": "published-release-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "a99357de764804abbe6d8bb917a0d23bbefe808d2e36b2b656f4d19de46644da",
        "694491a947b4423bb8fc1d0dd0a6a568bbba9ca3f00f7f88d623afea6f4a9503"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "rabbit-published-technical",
      "kind": "published-release-review",
      "family": "rabbit",
      "variantIds": [
        "rabbit-selected"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2",
        "f46341d730024ddb2a582438be85c30b4bfc391cb4b48d466302c39d781074a6"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "rabbit-generic-anatomy-534",
      "kind": "bounded-native-visual-review",
      "family": "rabbit",
      "dimensions": [
        "anatomy"
      ],
      "artifactId": "sha256:6c35e60794084cd6c9f5ff19fa6fb0b5a775f45c6bc94bc11562d6eaf5ac88c3",
      "sourceHashes": {
        "blender": "1710ecdbdde1c024180042f281c8d54c563a2b498dbda8466dfdcd4ce5fda7f9",
        "export-recipe": "5f4ce5de2c472eb313f133f069371e4a77eddb1cb823081af1d3a339d656c5b2"
      },
      "assetHashes": [
        "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2"
      ],
      "renderer": "webgl",
      "lods": [
        "full"
      ],
      "variantIds": [
        "rabbit-selected"
      ],
      "fixtureIds": [
        "rabbit-calibrated-rest",
        "rabbit-calibrated-movement"
      ],
      "date": "2026-10-11",
      "scope": "Bounded photo-informed generic anatomy and connected surface gate under actual landscape light; exact species anatomy remains unverified.",
      "limitations": [
        "Generic source identity; exact cottontail or white-tailed deer equivalence is not established.",
        "Faces, coats and muscle contours are simplified.",
        "Proxy macro anatomy is outside this full-detail visual claim."
      ]
    },
    {
      "id": "fish-published-technical",
      "kind": "published-release-review",
      "family": "fish",
      "variantIds": [
        "fish-selected"
      ],
      "artifactId": "sha256:c8144fa1209000ee5b50ccaa9eade8806120d001a82364189dc6cd29043e63d2",
      "scope": "Frozen published 534ce107 payload selection and reported contact, load, disposal, deterministic replay and Canvas orbit checks. This record is technical evidence, not species-level realism acceptance.",
      "sourceHashes": {
        "published-bundle": "534ce10760500963e9246371fe439528dee604cadfc04798f3ce71468abfbab8"
      },
      "assetHashes": [
        "ae16fd0a1a14723513deb35b529174973934247a8b8dd5ef842b9c0dff2dfde6",
        "a4f9555de163ced80c7ad5d39c51585de5f0493ec0c3566928f5da0d4fe4531a"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "published-release-replay",
        "canvas-all-family-orbit"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Exact species equivalence is not established.",
        "Canvas proxies remain lower detail.",
        "Phone performance has not been measured."
      ]
    },
    {
      "id": "robin-solid-host-534",
      "kind": "actual-mesh-collision-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "dimensions": [
        "contacts",
        "presentation"
      ],
      "artifactId": "sha256:27351d72e8c028f922bc180023cac1c8ad09f32ddf7393ae2fd5b0ea998aed91",
      "sha256": "27351d72e8c028f922bc180023cac1c8ad09f32ddf7393ae2fd5b0ea998aed91",
      "scope": "At seed1945, robin16 at t0 has2784/2986 transformed vertices inside the actual tapered pine trunk59. Robin15 at t23 has2174/2986 inside host shrub49 fruit. These are revision witnesses, not passes.",
      "assetHashes": [
        "a99357de764804abbe6d8bb917a0d23bbefe808d2e36b2b656f4d19de46644da"
      ],
      "renderer": "webgl",
      "lods": [
        "full"
      ],
      "fixtureIds": [
        "robin16-rest-trunk-seed1945",
        "robin15-rest-fruit-seed1945"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Leaf occlusion is separate from the solid-volume checks.",
        "The geometry correction belongs to the next shared obstacle-aware bird-placement revision."
      ]
    },
    {
      "id": "firefly04-anatomy",
      "kind": "native-scene-surface-review",
      "family": "firefly",
      "dimensions": [
        "anatomy"
      ],
      "artifactId": "sha256:9c2ef46883133898a9f1ba220547bce323d487da5cdf7e71fa3108722c389dc6",
      "sha256": "9c2ef46883133898a9f1ba220547bce323d487da5cdf7e71fa3108722c389dc6",
      "sourceHashes": {
        "blender": "ba541491a4774ba733c04e12a1cab2c151ecf18697c8242fc4ae8f82e5fc6aeb",
        "export-recipe": "52d44707e0d632d933cabceafee1cfa16f4900e9d6364bfbd9b84a08201d655a"
      },
      "assetHashes": [
        "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "variantIds": [
        "firefly-selected"
      ],
      "fixtureIds": [
        "firefly04-proxy-dark-flash-dark"
      ],
      "date": "2026-10-11",
      "scope": "Bounded photo-guided male surface/material gate: dark body, separate covers, curved membranes and two yellow ventral lantern plates under actual scene light.",
      "limitations": [
        "Pronotum, leg joints and membrane veins remain simplified.",
        "This visual scope does not establish courtship, flight aerodynamics or wrapped substrate contacts.",
        "The same compact payload is selected for both runtime modes; Canvas appearance requires its own final selected-scene check."
      ]
    },
    {
      "id": "firefly04-runtime",
      "kind": "native-temporal-lifecycle-review",
      "family": "firefly",
      "variantIds": [
        "firefly-selected"
      ],
      "artifactId": "sha256:7689cf608bd5c93a690b0d68f399cb73b79d8feb0eb401a5f16c82bc651cd5f2",
      "sha256": "7689cf608bd5c93a690b0d68f399cb73b79d8feb0eb401a5f16c82bc651cd5f2",
      "scope": "Corrected hinge and paused-load, replacement, disposal checks on the same compact04 payload; full integrated selected-scene replay remains pending.",
      "assetHashes": [
        "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "firefly04-runtime"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Manual-hook proof on exact asset/profile; final normal-manifest regression remains pending."
      ]
    },
    {
      "id": "firefly04-surface",
      "kind": "actual-vertex-support-review",
      "family": "firefly",
      "variantIds": [
        "firefly-selected"
      ],
      "artifactId": "sha256:be48b7d146f802a715a082affd2d71ef3c8a42364051b975164aa2d14a8bd169",
      "sha256": "be48b7d146f802a715a082affd2d71ef3c8a42364051b975164aa2d14a8bd169",
      "scope": "23,232 full/proxy poses and 61,657,728 actual vertices clear rendered ground, conservative water crest and case across recorded origins. Rock/prop intersections remain outside this scope.",
      "assetHashes": [
        "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "firefly04-surface"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Manual-hook proof on exact asset/profile; final normal-manifest regression remains pending."
      ]
    },
    {
      "id": "robin10-native",
      "kind": "native-scene-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "artifactId": "sha256:7bcd7dc02bc550ef7d598dd68e6ce475e5498fb2e9493b08a9fea571aa15a267",
      "sha256": "7bcd7dc02bc550ef7d598dd68e6ce475e5498fb2e9493b08a9fea571aa15a267",
      "scope": "Actual full/proxy ordinary-focus perch and flight comparison; attached surfaces and compact tucked feet. Wrapped grip remains provisional.",
      "assetHashes": [
        "54607a09f39df438c4faf706cacf9808a936efbc6b7ffda9008335a14f906053",
        "40e30dc808a66ec86375abd5f5661606c500cc77ed83f06fde41e153acec3758"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "robin10-native"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Final selected-manifest and renderer-specific regression remains pending.",
        "Wrapped toe grip and simultaneous airborne pair collisions are outside the demonstrated contact scope."
      ]
    },
    {
      "id": "robin10-lifecycle",
      "kind": "guarded-adapter-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "artifactId": "sha256:0b74b1738a9f23651a5b51a996bd54751cb9cb9d203fe2c5cf39eb9145a18b75",
      "sha256": "0b74b1738a9f23651a5b51a996bd54751cb9cb9d203fe2c5cf39eb9145a18b75",
      "scope": "Exact full/proxy guarded load, reset, replacement, malformed-bind rejection and disposal. CPU decoder proof; GPU lifecycle remains a separate scope.",
      "assetHashes": [
        "54607a09f39df438c4faf706cacf9808a936efbc6b7ffda9008335a14f906053",
        "40e30dc808a66ec86375abd5f5661606c500cc77ed83f06fde41e153acec3758"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "robin10-lifecycle"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Final selected-manifest and renderer-specific regression remains pending.",
        "Wrapped toe grip and simultaneous airborne pair collisions are outside the demonstrated contact scope."
      ]
    },
    {
      "id": "robin10-host",
      "kind": "actual-vertex-host-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "artifactId": "sha256:ec3d3a3e820f337792f57897b84c3ec707eb33b456bf76308531c5269843c318",
      "sha256": "ec3d3a3e820f337792f57897b84c3ec707eb33b456bf76308531c5269843c318",
      "scope": "Actual full skin clears rendered support solids in the sampled weather corpus; nearest-foot gaps reach1.89mm. A wrapped claw grip is not established.",
      "assetHashes": [
        "54607a09f39df438c4faf706cacf9808a936efbc6b7ffda9008335a14f906053"
      ],
      "renderer": "webgl",
      "lods": [
        "full"
      ],
      "fixtureIds": [
        "robin10-host"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Final selected-manifest and renderer-specific regression remains pending.",
        "Wrapped toe grip and simultaneous airborne pair collisions are outside the demonstrated contact scope."
      ]
    },
    {
      "id": "robin10-proxy-host",
      "kind": "actual-vertex-host-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "artifactId": "sha256:49b9341b3b949bd70c2746b60345d9189962d0826b26abd93af01957be04e581",
      "sha256": "49b9341b3b949bd70c2746b60345d9189962d0826b26abd93af01957be04e581",
      "scope": "1,694 calm and wind-snow poses across four seeds; 3,720,024 deformed proxy vertices clear the real continuing twig outside intended feet, with positive floor clearance. Nearest-toe gap reaches 1.85 mm.",
      "assetHashes": [
        "40e30dc808a66ec86375abd5f5661606c500cc77ed83f06fde41e153acec3758"
      ],
      "renderer": "webgl",
      "lods": [
        "proxy"
      ],
      "fixtureIds": [
        "robin10-proxy-support-v6"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Proximity is measured; fully wrapped claw grip is not established."
      ]
    },
    {
      "id": "dragonfly6-surface",
      "kind": "actual-vertex-support-review",
      "family": "dragonfly",
      "variantIds": [
        "dragonfly-selected"
      ],
      "artifactId": "sha256:76902ad22300cb3587a8fd60f54608075f5dc571643e4fbeaf91f4acb200394a",
      "sha256": "76902ad22300cb3587a8fd60f54608075f5dc571643e4fbeaf91f4acb200394a",
      "scope": "Approved v6 geometry and four authored hinge transforms sampled through hover/dart; 5,784 poses and8.06million actual vertices clear terrain, water and case.",
      "assetHashes": [
        "1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "dragonfly-v6-surface"
      ],
      "date": "2026-10-11",
      "limitations": [
        "The same compact geometry is selected in both modes.",
        "Final normal-loader, Canvas appearance, lifecycle and aggregate performance remain pending."
      ]
    },
    {
      "id": "carp-photo5-source-runtime",
      "kind": "bounded-source-runtime-review",
      "family": "fish",
      "variantIds": [
        "fish-selected"
      ],
      "artifactId": "sha256:5b1393cab788f76bd29f68f38d315c6c70f900c20c212e275b1d746924869a0d",
      "sha256": "5b1393cab788f76bd29f68f38d315c6c70f900c20c212e275b1d746924869a0d",
      "sourceHashes": {
        "review-report": "5b1393cab788f76bd29f68f38d315c6c70f900c20c212e275b1d746924869a0d"
      },
      "assetHashes": [
        "4aafc94cc8eb0fcf4408eed0646c93f15c7d3ae401b80d261848d502dfc65ee5",
        "67843d62ef4ce3e3b44001c4972a5ff37d3d62850d627317de38574ae429271a"
      ],
      "renderer": "webgl",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "carp-photo5-source-runtime"
      ],
      "date": "2026-10-11",
      "scope": "Matched actual-water profile and swimming retain connected body/operculum, four barbels and the credited photo-derived coat. Full/proxy geometry and source rig checks passed their bounded review.",
      "limitations": [
        "Inset eye rings, fixed mouth and procedural fins remain simplified.",
        "Source photo lighting and mirrored coat are not calibrated albedo.",
        "Final selected-manifest lifecycle and Canvas proof remain pending."
      ]
    },
    {
      "id": "butterfly-fourwing5-source-runtime",
      "kind": "bounded-source-runtime-review",
      "family": "butterfly",
      "variantIds": [
        "butterfly-monarch",
        "butterfly-common-blue",
        "butterfly-cabbage-white"
      ],
      "artifactId": "sha256:a8a0f15e0edc0fccb10849fded2678f92c5adfa088e39f8b85c608741adde14c",
      "sha256": "a8a0f15e0edc0fccb10849fded2678f92c5adfa088e39f8b85c608741adde14c",
      "sourceHashes": {
        "review-report": "a8a0f15e0edc0fccb10849fded2678f92c5adfa088e39f8b85c608741adde14c"
      },
      "assetHashes": [
        "923017895d19fb66195f6f36531d778fb0435022b1b4f8e97afcf60cb69cdf8d",
        "ba8e275a7cbbf52343b0db2a752b50d83296beb646724a34e001de433b3777b4",
        "d0cdda684c49353ef730adf0bafc47834f9ea19f1632de231920f0ed2887d745",
        "87412e3b183f24784bbc169b4d74b5e99e0ebaa44c41386247a2cd2e4e6792fe",
        "7221d77a8d8b95bfaeb713212a6f52fdf877a7e9503dc986c70738c5825e5db7",
        "0dfb73beb824360925745af70637628313219364760bf87a7ec399a84fd682f2"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "butterfly-fourwing5-source-runtime"
      ],
      "date": "2026-10-11",
      "scope": "Independent fore/hind overlap, dorsal/ventral faces and takeoff/landing stay attached in actual Three. Earlier landing closure clears the recorded clover intersection; full/proxy host sweeps remain hash-scoped technical evidence.",
      "limitations": [
        "Species wingbeat and joint angles are engineering approximations.",
        "No proboscis extension or nectar-transfer behavior is implemented.",
        "Selected-manifest lifecycle and fallback surfaces need the final source check."
      ]
    },
    {
      "id": "frog-bank-stance-handoff",
      "kind": "source-and-runtime-review",
      "family": "frog",
      "variantIds": [
        "frog-selected"
      ],
      "artifactId": "sha256:d3f4bec8ccdef635b8311ac8cbbfc5380b991281c01a950818ebf2e3e1873769",
      "scope": "Four-seed full/compact actual skinned geometry, active stance and continuous boundary checks, plus primary push/catch/settle witnesses. Exact imported hook and corrected Canvas terrain were separately reconciled; default selection is pending.",
      "sourceHashes": {
        "authored-final-adapter": "5aae2f0070f9686651d826850e139f22feb56b4844ea9be60e5bde57f4c7edee"
      },
      "assetHashes": [
        "001c74bda3317d7a2b83ad56ec21277064df7e8c017da1ca432b5dbbdc192df3",
        "eaaa929aa67c36e01d6848633fa33e39741d9961459666a621a7c61d6054ba04"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "four-seed-stance-corpus",
        "seed42-frog22-push",
        "seed17-frog21-catch-settle",
        "canvas-bank-v21"
      ],
      "date": "2026-10-11",
      "limitations": [
        "No swimming or certified planted turns.",
        "No all-prop collision claim.",
        "Full mesh is preferred for close anatomy; compact proxy has a local hidden thigh-fold deviation.",
        "Normal selection loader and focus are pending."
      ]
    },
    {
      "id": "wren-grounded-scene-handoff",
      "kind": "source-and-runtime-review",
      "family": "wren",
      "variantIds": [
        "wren-selected"
      ],
      "artifactId": "sha256:1b0c6aa1aeb71092f702febbc55a1c0c0579d69c2204866d50a73a21ef0fe066",
      "scope": "Four-seed full/proxy actual skin and shared rendered-wood checks; all eight wrens retained. Clear native grounded support, 210 departure/return frames, Canvas views and UV-only final-source reconciliation. Default selection awaits normal-loader reconciliation.",
      "sourceHashes": {
        "reviewed-bundle": "8659e4afe1793c20332fd257fe2d191f2bd292b80d3aa94de28ec9d804245cbc"
      },
      "assetHashes": [
        "f67060c85c3f63a6ecf86bbc85dcf138aa9b81bcfc7c2f2c29c1df9dab0ab622",
        "283b0e6e7ea28dc4490caf68781a0656fdd10bc7d5b3e982e46a3d8c7b2389c6"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "four-seed-grounded-support",
        "seed17-wren20-rest-departure-return",
        "default-wren-pair"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Provisional toe proximity rather than wrapped claw grip.",
        "No overnight sheltered roost, courtship or song audio.",
        "No flight-versus-flight collision certificate.",
        "Approximately 19 Hz cadence is an engineering inference.",
        "Default selection pending normal-loader check."
      ]
    },
    {
      "id": "swallow-daytime-scene-handoff",
      "kind": "source-and-runtime-review",
      "family": "swallow",
      "variantIds": [
        "swallow-selected"
      ],
      "artifactId": "sha256:a61d4835ecbb36385ac1ebccc7074808abb6cc5f11592b961223bcdc5261e634",
      "scope": "Four-seed full/proxy actual support/scenery checks, all eight swallows and wrens retained; actual native rest/departure/return and Canvas pilot views. Normal selection still awaits final reconciliation.",
      "sourceHashes": {
        "reviewed-bundle": "a8946eee1041893a8e73cda73198c45368b305651258646dcc41f2bb27713224"
      },
      "assetHashes": [
        "8e91f7f2c7af33df403cf470ef4913181d8cda3c4dca1371b19c0cecfbdb5086",
        "0bf86659ca652a4bb3ba2bc242175b18d1f96fa9fdca819a50cd2f2a6126e9df"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "four-seed-daytime-rest",
        "seed1945-swallow17-rest-departure-return",
        "seed17-moved-wren19"
      ],
      "date": "2026-10-11",
      "limitations": [
        "Toe proximity rather than wrapped grip.",
        "No overnight roost, courtship, flocking or prey capture.",
        "No flight-versus-flight collision certificate.",
        "Active cadence conditions differ from the wind-tunnel study.",
        "Default selection pending normal-loader check."
      ]
    },
    {
      "id": "deer-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "deer",
      "variantIds": [
        "deer-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4",
        "5dc17284df270558928b161b459f8183611eee7701e1aaf3476e35400971899d"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "frog-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "frog",
      "variantIds": [
        "frog-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "001c74bda3317d7a2b83ad56ec21277064df7e8c017da1ca432b5dbbdc192df3",
        "eaaa929aa67c36e01d6848633fa33e39741d9961459666a621a7c61d6054ba04"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "butterfly-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "butterfly",
      "variantIds": [
        "butterfly-monarch",
        "butterfly-common-blue",
        "butterfly-cabbage-white"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "923017895d19fb66195f6f36531d778fb0435022b1b4f8e97afcf60cb69cdf8d",
        "87412e3b183f24784bbc169b4d74b5e99e0ebaa44c41386247a2cd2e4e6792fe",
        "ba8e275a7cbbf52343b0db2a752b50d83296beb646724a34e001de433b3777b4",
        "7221d77a8d8b95bfaeb713212a6f52fdf877a7e9503dc986c70738c5825e5db7",
        "d0cdda684c49353ef730adf0bafc47834f9ea19f1632de231920f0ed2887d745",
        "0dfb73beb824360925745af70637628313219364760bf87a7ec399a84fd682f2"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "dragonfly-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "dragonfly",
      "variantIds": [
        "dragonfly-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "firefly-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "firefly",
      "variantIds": [
        "firefly-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "robin-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "robin",
      "variantIds": [
        "robin-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "54607a09f39df438c4faf706cacf9808a936efbc6b7ffda9008335a14f906053",
        "40e30dc808a66ec86375abd5f5661606c500cc77ed83f06fde41e153acec3758"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "wren-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "wren",
      "variantIds": [
        "wren-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "f67060c85c3f63a6ecf86bbc85dcf138aa9b81bcfc7c2f2c29c1df9dab0ab622",
        "283b0e6e7ea28dc4490caf68781a0656fdd10bc7d5b3e982e46a3d8c7b2389c6"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "swallow-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "swallow",
      "variantIds": [
        "swallow-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "8e91f7f2c7af33df403cf470ef4913181d8cda3c4dca1371b19c0cecfbdb5086",
        "0bf86659ca652a4bb3ba2bc242175b18d1f96fa9fdca819a50cd2f2a6126e9df"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "rabbit-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "rabbit",
      "variantIds": [
        "rabbit-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2",
        "f46341d730024ddb2a582438be85c30b4bfc391cb4b48d466302c39d781074a6"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    },
    {
      "id": "fish-normal-selection-v26",
      "kind": "normal-selection-technical-review",
      "family": "fish",
      "variantIds": [
        "fish-selected"
      ],
      "artifactId": "sha256:c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sha256": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
      "sourceHashes": {
        "native-report": "c31025853b871c31dde78f8a932d49aa67311ca61b5484078a1dec466b69eba3",
        "reviewed-bundle": "b76845ef1496bde4ed6e6f6fbbda828232935d8aa7942eff6c7baa1198de1e6e",
        "optimized-native-report": "90d6a438d91761ea079f507324a466d87563a033d1b034fc1774756fb02cb386",
        "optimized-reviewed-bundle": "671ee03e8a1e884f17fcd950de2d18525392a54755d606e312ced265ca5d1ed9"
      },
      "assetHashes": [
        "4aafc94cc8eb0fcf4408eed0646c93f15c7d3ae401b80d261848d502dfc65ee5",
        "67843d62ef4ce3e3b44001c4972a5ff37d3d62850d627317de38574ae429271a"
      ],
      "renderer": "webgl-and-canvas",
      "lods": [
        "full",
        "proxy"
      ],
      "fixtureIds": [
        "normal-twelve-slot-load",
        "paused-focus-and-overview",
        "malformed-retention-and-replacement",
        "nineteen-skeleton-disposal",
        "cadence-and-reset"
      ],
      "date": "2026-10-11",
      "scope": "Normal selected loader and resource checks, exact before/after focus and authoritative pose/contact replay. Family-specific primary and Canvas source reconciliations are linked from the sealed report. This supersedes earlier normal-selection-pending notes without extending their biological scope. The v27 hidden-primitive update optimization preserves the matched authored outputs and pixels; current-clock whole-family and partial-variant fallback restoration were independently verified.",
      "limitations": [
        "Functional technical proof does not establish visual parity with reference photographs.",
        "Bird toe wrapping, species-specific unmeasured timing and unimplemented neighbor behaviors retain their per-entry limitations.",
        "Phone and whole-frame performance have not been measured."
      ]
    }
  ]
}
